const sk = {
  global: {
    my_resume: 'Moje CV',
    resume: 'CV',
    ok: 'Ok',
    or: 'alebo',
    and: 'a',
    step: 'Krok',
    yes: 'Áno',
    no: 'Nie',
    employment: 'Zamestnanie',
    from: 'Od',
    to: 'Do',
    start: 'Začiatok',
    end: 'Koniec',
    new: 'Nový',
    more_info: 'Viac info',
    trade: 'Živnosť',
    experience: 'Skúsenosť',
    place: 'Miesto',
    suggested: 'Navrhované',
    titles: {
      all_done: 'Hotovo',
      fill_out_form: 'Vyplniť formulár',
      sent: 'Odoslané',
      added: 'Pridané',
      saved: 'Uložené',
      welcome: 'Vaša registrácia bola úspešná! Vitajte v Koderii',
    },
    actions: {
      create_resume: 'Vytvoriť',
      save: 'Uložiť',
      recommend: 'Odporučiť',
      share: 'Zdieľať',
      upload_file: 'NAHRAŤ SÚBOR',
      send: 'Odoslať',
      continue: 'Pokračovať',
      back: 'Späť',
      select: 'Vyberte',
      delete: 'Vymazať',
      delete_account: 'Zrušiť účet',
      add_post: 'Pridať príspevok',
      open: 'OTVORIŤ',
      upload_files: 'NAHRAŤ SÚBORY',
      IMPORT: 'IMPORTOVAŤ',
      add_more: 'Pridať ďalšie',
      add: 'Pridať',
      add_another: 'Pridať ďalšiu',
      copy: 'Kopírovať',
      complete: 'Dokončiť',
      resend: 'Odoslať znovu',
      show_less: 'Zobraziť menej',
      unlock: 'Odomknúť',
      change_image: 'Zmeniť obrázok',
      change_logo: 'Zmeniť logo',
      publish: 'Publikovať',
      back_to_home_page: 'Späť na hlavnú stránku',
      edit: 'Upraviť',
      download: 'Stiahnuť',
      close: 'Zatvoriť',
      register: 'Zaregistrovať',
      confirm: 'Potvrdiť',
      more: 'Viac',
    },
    time: {
      monthly: 'Mesačné | Mesačne',
      annual: 'Ročné',
      today: 'Dnes',
      hour: 'hod',
      year: 'Rok',
      years: 'rok | roky | rokov',
      month: 'Mesiac',
      months: 'mesiac | mesiace | mesiacov',
      several_weeks: 'o niekoľko týždňov',
      months_3: '3 mesiace',
      months_6: '6 mesiacov',
      manday: 'manday',
      now: 'Teraz',
      later: 'Neskôr',
      january: 'Január',
      february: 'Február',
      march: 'Marec',
      april: 'Apríl',
      may: 'Máj',
      june: 'Jún',
      july: 'Júl',
      august: 'August',
      september: 'September',
      october: 'Október',
      november: 'November',
      december: 'December',
    },
    errors: {
      unknown: 'Vyskytla sa chyba. Skúste to znova neskôr, prosím.',
      already_exists: 'E-mailovú adresu už používa iný účet.',
      auth_expired_action_code: 'Platnosť tokenu vypršala.',
      auth_invalid_action_code: 'Neplatný token.',
      auth_user_disabled: 'Účet bol zablokovaný.',
      auth_user_not_found: 'Neplatné prihlasovacie údaje.',
      auth_weak_password: 'Heslo nie je dostatočne silné.',
      auth_email_already_in_use: 'E-mailovú adresu už používa iný účet.',
      auth_invalid_email: 'Neplatný e-mail.',
      auth_operation_not_allowed: 'Operácia nie je povolená.',
      auth_account_exists_with_different_credential: 'Účet už existuje s inými prihlasovacími údajmi.',
      auth_invalid_credential: 'Neplatné prihlasovacie údaje.',
      auth_wrong_password: 'Neplatné heslo.',
      auth_invalid_phone_number: 'Neplatné telefónne číslo.',
      auth_missing_phone_number: 'Chýba telefónne číslo.',
      auth_cancelled_popup_request: 'Kontextové okno bolo zatvorené.',
      auth_popup_blocked: 'Kontextové okno bolo zablokované.',
      auth_popup_closed_by_user: 'Kontextové okno bolo zatvorené pred dokončením operácie.',
      auth_user_token_expired: 'Platnosť tokenu vypršala.',
      auth_invalid_api_key: 'Neplatný API kľúč.',
      auth_network_request_failed: 'Vyskytla sa chyba siete. Skúste to znovu neskôr.',
      auth_requires_recent_login: 'Vyžaduje sa aktuálne prihlásenie.',
      auth_too_many_requests: 'Príliš veľa požiadavok v krátkom čase.',
      auth_invalid_password: 'Neplatné heslo.',
      auth_email_already_exists: 'E-mailová adresa sa už používa.',
      auth_phone_number_already_exists: 'Telefónne číslo sa už používa.',
      auth_insufficient_permission: 'Nemáte dostatočné oprávnenia.',
      auth_internal: 'Došlo k chybe. Prosím, skúste to znovu neskôr.',
      auth_social_login_provider: 'Tento e-mail je priradený k prihláseniu do sociálnej siete (napr. Google). Prihláste sa pomocou svojho účtu na sociálnej sieti alebo skúste použiť iný e-mail.',
      permission_denied: 'Nemáte dostatočné oprávnenia.',
      phone_codes_error: 'Pri načítavaní telefónnych kódov krajín sa vyskytol problém. Skúste to znova neskôr.',
      unexpected_error: 'Vyskytla sa neočakávaná chyba. Skúste to znova neskôr.',
      error_404: 'Pri načítavaní údajov „{name}“ sa vyskytol problém. Skúste to znova neskôr.',
      job_application_unavailable: 'Momentálne nie je možné sa o túto pracovnú pozíciu uchádzať.',
    },
    inputs: {
      examples: {
        name: 'Ján',
        email: 'jan.drahy@email.com',
        searchJob: 'Hľadaj Frontend, Linux, SQL...',
      },
      firstname_surname: 'Meno a priezvisko',
      email: 'E-mail',
      first_name: 'Meno',
      last_name: 'Priezvisko',
      password: 'Heslo',
      city: 'Mesto',
      experiences: 'Skúsenosti',
      phone: 'Telefónne číslo',
      profession: 'Profesia',
      technology: 'Technológie',
      name: 'Názov',
      company: 'Spoločnosť',
      position: 'Pozícia',
      title: 'Názov',
      search_expertise: 'Vyhľadať technológiu',
    },
    form_rules: {
      length_6: '6 a viac znakov',
      non_empty_field: 'Vyplňte prosím toto pole',
      valid_email: 'Vyplňte prosím platnú e-mailovú adresu',
      phone_number: 'Telefónne číslo musí byť vo formáte +421 9XX XXX XXX',
      min_3: 'Aspoň 3',
      not_valid_email: 'E-mail musí byť platnou e-mailovou adresou.',
      password_length: 'Heslo musí obsahovať najmenej 6 znakov.',
      min_1_technology: 'Prosím, zadajte aspoň 1 technológiu.',
      event_image_required: 'Obrázok podujatia je povinný.',
      event_name_required: 'Názov podujatia je povinný.',
      event_name_min_3_characters: 'Názov podujatia musí mať aspoň 3 znaky.',
      event_datetime_manadatory: 'Dátum a čas podujatia sú povinné.',
      link_format: 'Odkaz nemá správny formát (príklad: https://koderia.sk/podujatia).',
      event_reference_required: 'Odkaz na podujatie je povinný.',
      venue_required: 'Miesto konania podujatia je povinné.',
      event_description_required: 'Popis podujatia je povinný.',
      organizer_logo_required: 'Logo organizátora je povinné.',
      organizer_name_required: 'Názov organizátora je povinný.',
      organizer_website_required: 'Webstránka organizátora je povinná.',
      organizer_description_required: 'Popis organizátora je povinný.',
      organizer_description_long: 'Popis organizátora je príliš dlhý.',
      event_end_before_start: 'Koniec podujatia nesmie byť pred jeho začiatkom',
      required_field: 'Povinné pole',
      first_name_filled: 'Krstné meno musí byť vyplnené.',
      last_name_filled: 'Priezvisko musí byť vyplnené.',
      password_min_six_characters: 'Heslo musí obsahovať najmenej 6 znakov.',
      accept_terms_conditions: 'Musíte akceptovať zmluvné podmienky.',
      no_data: 'Nie sú k dispozícii žiadne údaje',
    },
    form_errors: {
      check_entered_information: 'Vyskytla sa chyba. Skontrolujte zadané informácie.',
      upload_photo_max_size_5mb: 'Fotografiu sa nepodarilo nahrať, maximálna veľkosť je 5 MB.',
      enter_name: 'Prosím, zadajte vaše meno.',
      enter_last_name: 'Prosím, zadajte vaše priezvisko.',
      enter_email: 'Prosím, zadajte email',
      select_phone_code: 'Prosím, vyberte predvoľbu svojej krajiny.',
      enter_phone_number: 'Prosím, zadajte vaše telefónne číslo.',
      valid_phone_number: 'Prosím, zadajte platné telefónne číslo.',
      forgot_profession: 'Zabudli ste vyplniť svoju profesiu?',
      select_available_from_date: 'Prosím, vyberte dátum dostupnosti',
      no_data_available: 'Žiadne dáta k dispozícii',
      select_utm_source: 'Prosím, vyberte ako Ste sa o nás dozvedeli',
      select_non_it_registration_reason: 'Prosím, vyberte dôvod registrácie',
    },
    deprecated: {
      agree_with_processing_personal_data_according_to_current_working: 'Súhlasím so spracovaním osobných údajov podľa aktuálneho znenia',
      privacy_policy_small: 'zásad o ochrane súkromia',
      confirm_that_koderia_contact_me_in_future: 'Potvrdzujem, že ma Koderia v budúcnosti môže kontaktovať',
    },
    expertiseTypes: {
      PROGRAMMING_LANGUAGE: 'Programovací jazyk',
      FRAMEWORK: 'Framework',
      DATABASE: 'Databáza',
      LIBRARY: 'Knižnica',
      LIBRARY_OR_FRAMEWORK: 'Knižnica / Framework',
      CLOUD: 'Cloud',
      TOOLS: 'Nástroje',
      PLATFORM_OR_TOOL: 'Platforma / Nástroj',
      METHODOLOGY: 'Metodológia',
      DEVOPS: 'Dev / Ops',
      OTHER: 'Iné',
    },
    expertiseLevel: {
      '0-1': 'Menej ako 1 rok',
      1: '1 rok',
      2: '2 roky',
      3: '3 roky',
      4: '4 roky',
      '5-10': '5 – 10 rokov',
      '10+': 'Viac ako 10 rokov',
    },
    utm_source: {
      referral: 'Odporúčanie',
    },
    non_it_registration_reasons: {
      student: 'Vzdelávam sa v oblasti IT a v budúcnosti by som sa chcel stať IT špecialistom',
      no_contact: 'Som IT človek, ale nechcem aby ste ma kontaktovali s ponukami práce',
      try_tools: 'Chcem len vyskúšať Koderia nástroje (napr. Mzdová kalkulačka, Moje CV)',
    },
  },
  ad: {
    not_interested_in_any_position: 'Nezaujala Vás žiadna pozícia? Povedzte nám, čo musí spĺňať ideálny projekt a my ho nájdeme.',
    do_you_know_anyone_might_be_interested_in_this_position: 'Poznáte niekoho, koho by mohla táto pozícia zaujímať? Odporučte nám ho/ju a získavajte províziu',
    every_day: 'každý deň',
    you_can_also_have_commission_from_this_position: 'Aj z tejto pozície môžete mať províziu',
    do_you_know_anyone_might_be_interested_in_position: 'Poznáte niekoho, koho by mohli tieto pozície zaujímať? Odporučte nám ho/ju a získavajte províziu',
  },
  auth: {
    titles: {
      create_account: 'Vytvoriť účet',
      account: 'Účet',
    },
    subTitles: {
      account_advantages: 'Užívajte si bezplatne všetky výhody Koderia účtu',
      verification: 'Potrebné overenie účtu',
    },
    actions: {
      sign_in_simple: 'Prihlásiť',
      sign_up_simple: 'Zaregistrovať',
      sign_in: 'Prihlásiť sa',
      sign_up: 'Zaregistrovať sa',
      logout: 'Odhlásiť sa',
      create_new_account: 'Vytvorte si nový.',
      create_account: 'Vytvoriť účet',
      forgot_password: 'Zabudnuté heslo',
      sign_in_here: 'Prihláste sa tu.',
      sign_up_here: 'Zaregistrujte sa',
      verify: 'Poslať overenie',
    },
    descriptions: {
      check_email: 'Skontrolujte si svoju e-mailovú schránku, pre istotu aj priečinok spam. Ak sa Vám prihlásiť nepodarí, napíšte nám na',
      dont_have_account: 'Nemáte ešte svoj účet?',
      email_associated_with_koderia: 'Ak je uvedená e-mailová adresa priradená k účtu na Koderii, pošleme na ňu odkaz na obnovenie hesla.',
      check_confirmation_email: 'Skontrolujte si svoju e-mailovú schránku, na ktorú sme Vám zaslali potvrdzovací email.',
      check_welcome_email: 'Skontrolujte si svoju e-mailovú schránku, na ktorú sme Vám zaslali uvítacií email.',
      already_have_account: 'Máte už vytvorený účet?',
      advantage_1: 'Prístup k hodnotným službám Koderia',
      advantage_1_message: 'Obľúbené služby Adekvátny plat, Mzdová kalkulačka alebo Koderia Extra na jednom mieste',
      advantage_2: 'Jednoduchá reakcia na IT projekty',
      advantage_2_message: 'Na IT projekty a služby Koderia reagujete vďaka predvyplneným formulárom jednoducho jedným kliknutím',
      advantage_3: 'Personalizované pracovné ponuky',
      advantage_3_message: 'Pracovné ponuky prispôsobené a zoradené na základe Vašej špecializácie',
      advantage_4: 'Transparentná spolupráca',
      advantage_4_message: 'Prehľad o Vašich údajoch a využitých službách, ku ktorým sa môžete kedykoľvek vrátiť alebo ich upraviť',
      verification_dialog_message: 'Pre prístup do tejto časti overte svoju e-mailovú adresu. Na váš registrovaný e-mail sme poslali overovací odkaz. Pokračujte kliknutím na odkaz v e-maile. Ak ste e-mail nedostali, skontrolujte si priečinok so spamom alebo požiadajte o nový overovací e-mail.',
      non_it_description: 'Ak vyberiete možnosť, že nie ste z oblasti IT, nebudeme Vás kontaktovať ani Vám ponúkať prácu na projektoch. Ak sa však v budúcnosti rozhodnete zmeniť svoje zameranie, môžete to kedykoľvek upraviť vo svojom profile. Ak ste si len nesprávne vybrali profesiu, alebo sa neviete správne zaradiť, vyberte prosím možnosť OTHER.',
    },
    inputs: {
      remember_login: 'Zapamätať prihlásenie',
    },
  },
  cookie: {
    description: 'Webová stránka Koderia.sk používa k poskytovaniu služieb a analýze návštevnosti súbory cookies. Pokračovaním v prezeraní súhlasíte s ich používaním.',
    more_information: 'Viac informácií.',
    button: 'Rozumiem a súhlasím',
  },
  navigation: {
    titles: {
      job_offer: 'Pracovné ponuky',
      legal_information: 'Právne informácie',
      social_network: 'Sociálne siete',
      it_specialists: 'Pre IT špecialistov',
      companies: 'Pre firmy',
      menu: 'Menu',
      next: 'Ďalšie',
    },
    home: 'Domov',
    jobs: 'IT projekty',
    companies: 'Pre firmy',
    specialists: 'Pre IT špecialistov',
    carrier: 'Kariera',
    events: 'Podujatia',
    blog: 'Blog',
    newsfeed: 'Newsfeed',
    dictionary: 'Slovník',
    what_is_koderia: 'Čo je Koderia?',
    adequate_salary: 'Adekvátny plat',
    calculator: 'Mzdová kalkulačka',
    work_comparison: 'Porovnanie práce',
    work_types_comparison: 'Porovnanie foriem práce',
    koderia_referral: 'Koderia Referral',
    koderia_extra: 'Koderia Extra',
    privacy_policy: 'Zásady ochrany osobných údajov',
    resume: 'CV',
    create_resume: 'Vytvoriť CV',
    terms_conditions: 'Zásady o ochrane súkromia',
    koderia_dictionary: 'Koderia Slovník',
    about_us: 'O nás',
    contact_us: 'Kontakt',
    policy: 'Zasady',
    settings: 'Nastavenia',
    create_new_koderia_biography: 'Vytvoriť nový Koderia CV',
    company_services: 'Služby',
    company_cases: 'Prípadové štúdie',
  },
  homepage: {
    home: 'Domovská stránka',
    subtitles: {
      blogs: 'Najnovšie blogy',
      career_it: 'Kariéra pre IT špecialistov',
      company_solutions: 'IT riešenia <br /> pre firmy',
      cv_feature: 'Moderné a prehľadné CV.<br /> Pre každého v IT.<br /> Bezplatne.',
      adequate_salary_feature: 'Adekvátny plat',
      salary_calculator_feature: 'Mzdová kalkulačka',
      they_said: 'Povedali o nás',
      our_projects: 'Našie projekty',
      companies_trust: 'Dôverujú nám popredné spoločnosti',
      open_projects: 'Otvorené IT projekty',
      features: 'Vytvorené pre vás. Bezplatne',
    },
    descriptions: {
      career_it: 'Ak hľadáte skutočný rast vo svojej kariére v oblasti IT, ste na správnom mieste. Naša platforma ponúka príležitosti, ktoré môžu prekročiť vaše očakávania. Vyskúšajte niečo nové a objavte všetko, čo môžete dosiahnuť.',
      company_solutions: 'Hľadáte IT špecialistov pre váš projekt alebo riešenie na mieru?',
      cv_feature: 'Vytvorte si responzívny životopis za pár minút,<br /> ktorý môžete kedykoľvek upravovať, zdieľať alebo tlačiť.',
      adequate_salary_feature: 'Ako sa oceňujú zručnosti a skúsenosti,<br /> ktoré ste doteraz nadobudli?',
      salary_calculator_feature: 'Pracujete na trvalý pracovný pomer?<br /> Zistite, koľko by ste zarobili<br /> ako freelancer alebo cez sro.',
    },
    actions: {
      show_all: 'Zobraziť všetko',
      show_projects: 'Zobraziť IT projekty',
      more_info: 'Viac info',
    },
  },
  project: {
    title: 'Plánuje váš kolega, priateľ či známy zmeniť prácu?',
    subtitles: {
      referral: 'Plánuje váš kolega, priateľ či známy zmeniť prácu?',
      extra: 'Nezaujala Vás žiadna pozícia?',
    },
    descriptions: {
      referral: 'Odporučte ho na niektorý z našich projektov a v prípade úspešnej dohody získavajte províziu každý deň.',
      extra: 'Vyplňte krátky formulár a my pre Vás budeme hľadať <br class="tw-hidden md:tw-block" /> projekt podľa zvolených požiadaviek.',
    },
    actions: {
      learn_more: 'Zistiť viac',
      reset_filters: 'Resetovať filtre',
    },
    detail: {
      status: {
        not_available: 'Tento projekt už bol obsadený alebo nie je aktuálny.',
        new: 'Nové',
        remote: 'Remote',
        already_responded: 'Na túto ponuku ste už reagovali',
      },
      subtitles: {
        position: 'Popis pozície',
        hr_need_info: 'Potrebujete viac info?',
        interest_contacts: 'Kontaktné informácie a CV',
        good_news: 'Dobré správy',
        interest_upload_resume: 'Nahrať CV teraz?',
      },
      descriptions: {
        useful_for_you: 'Podľa info vo Vašom profile a CV by sa Vám tento job mohol hodiť. Nezmeškajte príležitosť pracovať na tom, čo vám ide.',
        create_resume: 'Vytvorte si Koderia CV a zistite, ako sa vaše skúsenosti zhodujú s požiadavkami na túto pracovnú ponuku.',
        team_contacts_you: 'V priebehu nasledujúcich dní Vás kontaktuje člen/ka nášho tímu a dohodne sa s Vami na ďalšom postupe.',
        modern_resume: 'Moderný a prehľadný CV pre <br class="md:tw-hidden" /> každého v IT.',
        hr_contact_directly: 'Obráťte sa priamo na našich recruiterov, ktorí vám radi povedia viac.',
        interest_team_contacts_you: 'Ďakujeme za Váš záujem, čoskoro Vás budeme kontaktovať.',
        interest_recommended_upload: 'Odporúčame nahrať teraz, budeme ho potrebovať.',
      },
      actions: {
        respond_to_offer: 'Reagovať na ponuku',
        all_jobs: 'Všetky joby',
      },
      salary: 'Plat',
      location: 'Lokalita',
      views: 'zobrazenie | zobrazenia | zobrazení',
      candidates: 'kandidát | kandidáti | kandidátov',
      requirements: 'Požiadavky',
      employer_benefits: 'Výhody zamestnávateľa',
      project_duration: 'Dĺžka projektu',
      duration_extension: 's možnosťou predĺženia',
      start_date: 'Dátum nástupu',
      type: 'Typ',
      tpp: 'TPP',
      contract: 'Kontrakt',
      agreement: 'Dohoda',
      project_language: 'Jazyk na projekte',
      similar_job: 'Podobné joby',
      free: 'Zadarmo',
      salary_per_contract: 'Plat na kontrakt',
      salary_per_tpp: 'Plat na TPP',
      top_offer: 'Top ponuka',
      email_reaction_to: 'Reakcia na',
      email_body: 'Prosím, nezabudnite pridať CV',
    },
  },
  event: {
    title: 'Nadchádzajúce podujatia',
    subtitles: {
      online: 'Online',
      slovakia_czech: 'Slovensko a Česko',
      event_info: 'Info o podujatí',
      organizer: 'Organizátor',
    },
    descriptions: {
      upload_cover_image: 'Nahrajte titulný obrázok',
      basic_information: 'Základné informácie o podujatí ako názov, miesto, popis a čas konania podujatia.',
      organizer_information: 'Stručné informácie o organizátorovi podujatia',
      no_scheduled_events: 'Momentálne nie sú plánované žiadne podujatia.',
    },
    detail: {
      action: 'Pridať do kalendára',
    },
    inputs: {
      event_link: 'Odkaz na podujatie',
      list: 'Popis',
      ticket_purchase_link_optional: 'Odkaz pre zakúpenie lístkov (Nepovinné)',
      webpage: 'Webstránka',
      description_of_organizer: 'Popis organizátora',
      date_and_time: 'Dátum a čas',
    },
    cover_image: 'Titulný obrázok',
    date_and_time: 'Dátum a čas',
    online_event: 'Online podujatie',
    organize_question: 'Organizujete podujatie?',
  },
  blog: {
    title: 'Koderia Blog',
    subtitles: {
      more_articles: 'Ďalšie články',
    },
    description: 'Píšeme o témach, ktoré rezonujú IT svetom',
    actions: {
      read: 'Prečítať',
      more_articles: 'Ďalšie články',
    },
    detail: {
      subtitle: 'Mohlo by Vás zaujímať',
    },
  },
  newsfeed: {
    title: 'Newsfeed',
    action: 'Ďalšie články',
  },
  questionaire: {
    title: 'Adekvátny plat',
    subtitles: {
      experience: 'Ako sú ocenené skúsenosti,<br class="tw-hidden lg:tw-block" /> ktoré ste doteraz nadobudli?',
      paid_jobs: 'Adekvátne zaplatené joby',
      evaluate_resume: 'Vyhodnotiť CV',
      choose_method: 'Vyberte si spôsob vyhodnotenia',
      about_you: 'Informácie o Vás',
      master_technologies: 'Technológie, ktoré ovládate',
      total_experience: 'Celkový počet rokov praxe',
      master_experience: 'Počet rokov praxe v',
      leadership_experience: 'Boli ste niekedy Team Leader alebo Scrum Master?',
      domain_experience: 'Máte skúsenosti s konkrétnou doménou?',
      domain_experience_examples: '(napr. Bankovníctvo, Medicína, Telekomunikácie, …)',
      software_architect_experience: 'Pracovali ste ako softvérový architekt?',
      type_of_tester: 'Aký typ testera ste?',
      ci_experience: 'Máte skúsenosti s CI technológiami Docker, Jenkins, GIT, ...?',
      performance_experience: 'Máte skúsenosti s programovaním performance testov?',
      job_listing_title: 'Pracovné pozície',
    },
    descriptions: {
      salary_evaluate: 'Váš plat vyhodnocujeme na základe skúseností, ktoré ste vo svojej kariére nadobudli. Vyhodnotenie prebieha nahraním CV alebo vyplnením formulára. Obe možnosti sú vysoko presné.',
      experience_evaluate_by_team: 'Vaše skúsenosti vyhodnotí člen/ka Koderia tímu.',
      experience_evaluate_by_system: 'Vaše skúsenosti vyhodnotí náš sofistikovaný systém.',
      experience_evaluate_by_pro_team: 'Vaše skúsenosti vyhodnotí člen/ka Koderia PRO tímu.',
      first_step: 'V prvom kroku je dôležité zistiť, ktoré technológie ovládate a počet rokov Vašej praxe.',
      second_step: 'V druhom kroku uveďte doplňujúce informácie o svojej doterajšej kariére.',
      third_step: 'Nakoniec nám nechajte svoje meno a e-mail, na ktorý pošleme výsledok formulára.',
      answer_questions: 'Odpovedzte na nasledujúce otázky.',
      thank_you: 'Ďakujeme za Váš záujem, čoskoro Vás budeme kontaktovať.',
    },
    actions: {
      all_jobs: 'Všetky joby',
      upload_resume: 'Nahrať CV',
    },
    inputs: {
      choose_position: 'Vyberte si pozíciu',
    },
    programmer: 'Programátor',
    tester: 'Tester',
    it_specialist: 'IT špecialista',
    project_manager: 'Projektový manažér',
    analyst: 'Analytik',
    automated_tester: 'Automatizovaný tester',
    manual_tester: 'Manuálny tester',
  },
  calculator: {
    title: 'Mzdová kalkulačka',
    subtitles: {
      only_for_slovak: '',
      possible_earnings: 'Pracujete na trvalý pracovný pomer?<br class="tw-hidden lg:tw-block" />Zistite, koľko by ste zarábali na <b>živnosť</b> alebo <b>s.r.o.</b>',
      find_out_more: 'Zistite viac, <span class="tw-text-green">zadarmo</span>.',
      billing_options: 'Možnosti fakturácie',
      price_md: 'Cena za človekodeň',
      price_md_sup: '(Man-day Rate)',
      recommended_job_offers: 'Pracovné ponuky pre teba',
    },
    actions: {
      calculate: 'Vypočítať',
      find_job: 'Nájdi prácu',
      get_hired: 'Zamestnaj sa',
    },
    descriptions: {
      main: 'Nástroj Mzdová kalkulačka vypočítava sumu, ktorú by ste mali fakturovať, ak pracujete na živnosť alebo S.R.O. z TPP tak, <b>aby sa náklady zamestnávateľa nezvýšili.</b>',
      current_income: 'Vaše aktuálne príjmy a odvody na trvalom pracovnom pomere.',
      more_after_login: 'Radi vám <strong class="tw-font-bold">zdarma</strong> ukážeme viac, po príhlásení.',
      more_after_verify: 'Radi vám <strong class="tw-font-bold">zdarma</strong> ukážeme viac, po overení Vášho emailu.',
      your_md_rate: 'Aká je vaša cena za človekodeň (Man-day Rate)',
      earn_for_trade: 'Koľko budete zarábať na živnosť',
      earn_on_sro: 'Koľko budete zarábať na s.r.o.',
      fees_and_taxes: 'Aké odvody a dane budete platiť',
      option_for_you: 'Ktorá možnosť sa pre vás oplatí viac',
      net_monthly_income: 'Toto je suma, ktorú by ste mali dostať pri prechode na faktúru.',
    },
    inputs: {
      gross_monthly_income: 'Zadajte svoj hrubý mesačný príjem (min 700 €)',
    },
    taxes: 'dane',
    net_monthly_income: 'Čistý mesačný príjem',
    months_worked_in_year: 'Odpracované mesiace v roku',
    super_gross_annual_salary: 'Superhrubá ročná mzda',
    employer_levies: 'Odvody zamestnávateľa',
    employee_contributions: 'Odvody zamestnanca',
    invoice_for_year: 'Faktúrované za rok',
    deductions_together: 'Odvody spolu',
    income_tax: 'Daň z príjmu',
    price_md: 'Cena za človekodeň',
    invoice_md: 'Suma, ktorú by ste si mali fakturovať za 1 odpracovaný deň.',
    trade_first_year: 'Živnosť v prvom roku',
    trade_2nd_and_next_year: 'Živnosť v 2. a ďalšom roku',
    average_net_monthly_income: 'Priemerný čistý mesačný príjem',
    taxes_and_levies: 'Dane a odvody',
    health_insurance_contributions: 'Odvody do zdravotnej poistovne',
    social_insurance_contributions: 'Odvody do sociálnej poistovne',
    together: 'Spolu',
    billing_options_learn_more: 'Viac o možnostiach fakturácie sa dozviete v',
    billing_options_learn_more_link: 'tomto článku.',
    company_sro: 'Spoločnosť (s.r.o.)',
    company_tax: 'Dane spoločnosti',
    dividend_tax: 'Daň z dividend',
    total_taxes: 'Dane spolu',
    overview: 'Prehľad',
    price_of_labor: 'Cena práce',
    super_gross_salary: 'Superhrubá mzda',
    gross_salary: 'Hrubá mzda',
    gross_salary_after_tax: 'Hrubá mzda po zdanení',
    net_income: 'Čistý príjem',
    average_invoice: 'Priemerná faktúra',
    company_profit: 'Zisk spoločnosti',
    gross_tax_base: 'Hrubý daňový základ',
    flat_cost: 'Paušálne náklady',
    health_insurance: 'Zdravotné poistenie',
    social_insurance: 'Sociálne poistenie',
    view_detailed_taxes_and_levies: 'Zobraziť podrobné dane a odvody',
  },
  work_comparison: {
    title: 'Porovnanie foriem práce',
    subtitle: 'Zistite, ktorá z foriem <br class="tw-hidden lg:tw-block" />práce je pre vás najvhodnejšia',
    subheadings: {
      accounting: 'Účtovníctvo',
      establishment: 'Založenie',
      taxes: 'Dane',
      non_taxable_part: 'Nezdaniteľná časť',
      levies: 'Odvody',
    },
    descriptions: {
      main: 'Detailné porovnanie trvalého pracovného pomeru, <br class="tw-hidden lg:tw-block" />živnosti a spoločnosti s ručením obmedzeným (s.r.o.)',
      taxes_follows_law: 'Zo znenia zákona vyplýva, že {percentage}% sadzba dane bude od roku {year} uplatniteľná daňovníkom s obratom do {grossTax} €.',
      annual_amount_non_taxable_part: 'Ročná výška nezdaniteľnej časti základu dane na daňovníka v roku {year} je {untaxablePartOfTaxBase} € ak základ dane nižší alebo rovný ako {minimumTaxBase} €. Od tejto sumy až kým je základ dane vyšší ako suma {milionaireTaxBase} € klesá nezdaniteľná časť až k nule.',
      social_insurance_not_paid: 'Sociálne poistenie sa neplatí. Zdravotné poistenie sa platí minimum. V ďalších rokoch sociálne odvody platí, ak v predošlom roku prekročil hranicu príjmov {minimumYearWage} € (za rok {year}), odvody sa zvyšujú spolu s príjmom; do zdravotnej poistovne platí aj ked nič nezarobí (minimálna výška odvodov je {minimumMedicalTax} € mesačne).',
      manager_one_person: 'Ak je konateľ jedna osoba a nevypláca si mzdu, nemusí platiť odvody do sociálnej poisťovne a do zdravotnej platí ako samoplatca; ak je však konateľ aj zamestnancom, musí platiť odvody aj do zdravotnej, aj do sociálnej poisťovne.',
    },
    permanent_employment: 'Trvalý pracovný pomer',
    self_employed_person: 'Samostatne zárobkovo činná osoba',
    limited_liability_company: 'Spoločnosť s ručením obmedzeným',
    simple: 'jednoduché',
    double: 'podvojné',
    income_tax: 'daň z príjmu',
    dividend_tax: 'daň z dividend',
    other: 'Iné',
    holiday: 'dovolenka',
    sick_leave: 'PN',
    retirement_savings: 'dôchodkové sporenie',
    low_contributions_low_pension: 'nízke odvody = nízky dôchodok',
    benefits: 'Výhody',
    disadvantages: 'Nevýhody',
    regular_income: 'pravidelný príjem',
    financial_benefits: 'finančné aj nefinančné benefity',
    get_loan: 'jednoduchšie získanie pôžičky',
    lower_salary: 'menší plat',
    working_hours: 'presne stanovený pracovný čas',
    notice_period: 'výpovedná lehota',
    fast_establishment_process: 'rýchly a lacný proces založenia',
    possible_flat_rate_expenses: 'možnosť využitia paušálnych výdavkov',
    social_contributions_exemption: 'oslobodenie od platenia sociálnych odvodov počas 1. roka',
    unlimited_liability: 'neobmedzené ručenie',
    health_social_contributions_amount: 'zdravotné a sociálne odvody závisia od výšky príjmu',
    less_credible_image: 'menej dôveryhodný imidž (pre obchodných partnerov môže budiť dojem malého podnikateľa)',
    limited_liability: 'obmedzené ručenie',
    credible_image: 'lepší a dôveryhodnejší imidž (budí dojem väčšieho a serióznejšieho podnikateľa pre obchodných partnerov a potenciálnych zamestnancov)',
    equal_income_tax: 'rovná daň z príjmu bez ohľadu na dosiahnuté príjmy',
    expensive_founding_process: 'dlhší a drahší proces založenia vrátane potreby vypracovania zakladateľských dokumetov',
    demanding_administration: 'náročnejšia a drahšia administratíva (povinné vedenie podvojného účtovníctva), 50-70 eur/mesiac',
    termination_process: 'komplikovanejší proces ukončenia',
    graph_net_income: 'Grafové porovnanie čistého príjmu',
    company: 'Spoločnosť',
    trade_after_first_year: 'Živnosť po prvom roku',
    temporary_incapacity_for_work: 'Dočasná pracovná neschopnosť',
    gross_salary: 'Hrubá mzda (Fakturovaná suma)',
    chart_popup_more_info: 'Pre presnejšie dáta navštívte mzdovú kalkulačku',
  },
  extra: {
    title: 'Extra',
    subtitles: {
      your_idea: 'Povedzte nám, ako má vyzerať <br class="tw-hidden lg:tw-block" />práca podľa Vašich predstáv',
      project_information: 'Informácie o projekte',
      information_about_you: 'Informácie o Vás',
      preferred_technologies: 'Preferované technológie',
    },
    descriptions: {
      no_interested_position: 'Nezaujala Vás žiadna pozícia? Vyplňte krátky formulár a my pre Vás budeme hľadať projekt podľa zvolených požiadaviek',
      will_be_in_touch: 'Ďakujeme, čoskoro budeme v kontakte. Zatiaľ si môžete pozrieť čo je nové na domovskej stránke.',
    },
    inputs: {
      date_of_start: 'Dátum začiatku',
      phone_number_optional: 'Telefónne číslo (Nepovinné)',
      question_or_additional_info: 'Otázky alebo dodatočné info (Nepovinné)',
    },
    junior_less_than_2_years: 'Junior (menej ako 2 roky)',
    medior_2_4_years: 'Medior (2 – 4 roky)',
    senior_5_and_more: 'Senior (5 a viac rokov)',
  },
  referral: {
    title: 'Koderia Referral',
    subtitles: {
      colleague_planning: 'Plánuje Váš kolega, priateľ <br class="tw-hidden lg:tw-block" />či známy zmeniť prácu?',
      how_it_works: 'Ako to funguje?',
      forms_of_payment: 'Formy vyplácania',
      one_time_commission: 'jednorázová provízia',
      worked_day: 'za každý odpracovaný deň',
      ready_to_collaborate: 'Pripravený na spoluprácu?',
      candidate_information: 'Informácie o kandidátovi',
      information_about_you: 'Informácie o Vás',
      you_should_know: 'Mali by ste vedieť',
    },
    descriptions: {
      recommend_projects: 'Odporučte ho na niektorý z našich projektov a v prípade úspešnej dohody získavajte províziu každý deň.',
      friend_looking: 'Jednoducho. Vy nám dáte vedieť o svojom priateľovi, kolegovi alebo známom, o ktorom viete, <br class="tw-hidden lg:tw-block" />že hľadá prácu v IT. My ho umiestnime na niektorý z našich projektov a provízia je vaša.',
      fill_short_form: 'Vyplníte krátky formulár, na základe ktorého Vášho známeho kontaktujeme.',
      interview_with_you: 'Nasleduje pohovor u nás alebo u klienta, po ktorom zistíme, či sme sa našli.',
      concluding_contract: 'Uzatvorenie zmluvy s úspešným kandidátom a vyplatenie provízie.',
      one_time_commission: 'Jednorázovú províziu vyplácame po prvých troch odpracovaných mesiacoch. 5 € za každý odpracovaný deň vyplácame mesačne, od začiatku do konca projektu. V prípade projektov kratších ako 6 mesiacov vyplácame 500 € alebo tiež 5 € za každý odpracovaný deň. Províziu vyplácame aj v prípade, že sa s kandidátom dohodneme na inej pozícii.',
      recommendation_touch_soon: 'Ďakujeme za Vaše odporúčanie, čoskoro budeme v kontakte. Zatiaľ si môžete pozrieť čo je nové na domovskej stránke.',
      recommend_to_position: 'Odporúčate známeho na konkrétnu pozíciu?',
      preferred_type_of_provision: 'Aký typ provízie preferujete? (Nepovinné)',
      change_provision_type: 'Vybraný typ provízie môžete kedykoľvek zmeniť.',
      forms_of_reward: 'Formy odmeny sú: jednorázová provízia vo výške <b>1000 €</b>, ktorú vyplácame po prvých troch odpracovaných mesiacoch alebo <b>5&nbsp;€ za každý odpracovaný deň</b>, od začiatku do konca projektu (vyplácané mesačne).',
      shorter_projects: 'V prípade projektov kratších ako 6 mesiacov vyplácame 500 € alebo tiež 5 € za každý odpracovaný deň.',
      receive_commission: 'Províziu dostanete aj v prípade, že sa s kandidátom dohodneme na inej pozícii.',
      data_deleted_from_db: 'Vaše údaje budú vymazané z našej databázy.',
      recommended_you: 'Vás odporúčil na jednu z našich voľných pozícií. V prípade, že nepoznáte osobu, ktorá nám poslala Vaše informáce, kliknite na tlačidlo nižšie a vymažte svoje údaje.',
    },
    inputs: {
      current_position: 'Súčasná pozícia',
    },
    one_time_1000: '1 000 € jednorázovo',
    per_day_worked_5: '5 € za každý odpracovaný deň',
    record_not_found: 'Záznam sa nenašiel.',
  },
  koderia_about: {
    title: 'Čo je Koderia?',
    descriptions: {
      unique_project: 'Koderia je unikátny projekt, kde si na svoje prídu všetci programátori či programátorky, nadšenci IT, študenti a študentky technických predmetov, ale i ľudia, ktorým je blízky svet IT. Čo všetko Koderia ponúka zistíte nižšie.',
      homepage: 'Domovská stránka Koderie je odrazovým mostíkom pre všetky funkcie a možnosti, ktoré ponúkame. Nájdete na nej najnovšie pracovné ponuky, príspevky zo svetových portálov, IT podujatia na Slovensku ale aj online zo sveta a mnoho iného.',
      job_section: 'V sekcii práca nájdete najnovšie pracovné ponuky. Sprostredkúvame prácu do firiem, ktoré sú lídrami vo svojom obore na Slovensku, v Česku a Rakúsku. Pod záštitou máme už desiatky kóderov a kóderiek.',
      looking_for_colleague: 'Hľadá si váš kolega, priateľ či známy prácu v IT? Dajte nám o ňom vedieť a v prípade vzájomnej dohody a následnej spolupráce sa s vami rozdelíme s províziou. Môžete tak získavať 5 € denne alebo jednorázovú sumu 1000 €.',
      interested_offer: 'Nezaujala vás žiadna pracovná ponuka? Vyplnením krátkeho formuláru na našej stránke nám môžete dať vedieť, o akú pozíciu máte záujem a my vás budeme kontaktovať v prípade, ak sa o takejto ponuke dozvieme.',
      modern_resume: 'Moderný a prehľadný CV, ktorý dokážete jedným klikom zdieľať či vytlačiť, by mal byť v súčasnosti samozrejmosťou pre každého, hlavne v IT sektore.',
      salary_tool: 'Jednoduchý nástroj, ktorý určuje výšku adekvátneho platu na základe skúseností.',
      trade_to_sro: 'Vypočítanie fakturovanej sumy pri prechode z TPP na živnosť alebo s.r.o.',
      blog: 'Blogu patrí samostatná stránka. Píšeme v ňom o témach, ktoré rezonujú IT svetom a o myšlienkach, s ktorými sa stotožňujeme.',
    },
  },
  profile: {
    title: 'Koderia účet',
    subtitles: {
      email_settings: 'E-mailové nastavenia',
      invalid_link: 'Neplatný odkaz',
      thank_you: 'Ďakujeme',
      linkedin_import_data: 'Importovanie údajov z LinkedIn',
      account_settings: 'Nastavenia účtu',
      newsletter: 'Newsletter',
      basic_settings: 'Základné nastavenia',
      delete_account: 'Naozaj chcete zrušiť účet?',
      confirm_email_address: 'Potvrdenie e-mailovej adresy',
      finish_signup: 'Skôr ako začnete, <br class="tw-hidden lg:tw-block" />povedzte nám <br class="tw-hidden lg:tw-block" />niečo o sebe.',
    },
    descriptions: {
      invalid_link: 'Odkaz nie je platný alebo jeho platnosť vypršala',
      recommended_salary: 'Váš plat by nemal byť nižší ako',
      find_out_recommended_salary: '<span>Vyplňte sekciu <a href="#" @click.prevent="$emit(\'go-to-experience\')" class="tw-text-black">skúsenosti</a> a zistite,</span><br /><span>koľko by ste mali zarábať.</span>',
      approval_of_contribution: 'O schválení príspevku Vás budeme informovať. Svoje pridané príspevky následne nájdete v menu, v sekcii „Pridané“.',
      share_original_posts: 'Zdieľajte s nami originálne príspevky, ktoré vás na internete zaujali.',
      no_posts: 'Zatiaľ nemáte pridané žiadne príspevky.',
      linkedin_open_personal_data: 'Otvorte si podstránku o svojich osobných údajoch',
      linkedin_use_your_data: 'How LinkedIn uses your data',
      linkedin_download_large_data: '<p class="step-info">Zvoľte možnosť <strong>Download larger data archive…</strong></p>',
      linkedin_request_archive: '<p class="step-info">Následne kliknite na <strong>Request archive</strong></p>',
      linkedin_unzip_file: 'Súbor, ktorý si stiahnete, rozbaľte a nahrajte nám súbory',
      linkedin_provide_file: 'Berte prosím na vedomie, že LinkedIn vám súbor nemusí poskytnúť ihneď.',
      import_click: 'Následne kliknite na <strong>Importovať</strong>.',
      private_resume: 'CV je nastavený ako súkromný. Zmeniť to môžete v',
      token_resume_no_password: 'CV heslo nie je nastavené. Nastaviť ho môžete v',
      private_resume_change: 'nastaveniach, časť Súkromie',
      what_is_experience_chart: 'Čo predstavuje tento graf a ako funguje?',
      fill_in_experience_chart: 'Pre správne zobrazenie grafu, vyplňte svoje skúsenosti.',
      resume_link: 'Na tomto odkaze nájdete svoj CV vy a ľudia, s ktorými ho zdieľate.',
      resume_language: 'Jazyk, v ktorom je zobrazený CV.',
      resume_social_contact: 'Zobrazovanie e-mailu, telefónu a webstránky alebo sociálnej siete v CV.',
      resume_availability: 'Zvoľte pre koho chcete svoj CV sprístupniť.',
      account_password_not_allowed: 'Nezadávajte heslo od svojho účtu!',
      resume_password_viewing_only: 'Toto heslo slúži len pre zobrazenie CV a bude dostupné iba ľuďom, ktorým sa ho rozhodnete poskytnúť.',
      digital_experience_graph: 'Zobrazovanie grafu skúsenosti v digitálnej verzii CV.',
      positions_based_on_technologies: 'Nové pozície podľa technológií, ktoré ste uviedli v nastaveniach účtu.',
      sending_news: 'Všetko, čo sa je na našom portáli nové. Posielame priebežne – maximálne 1x za mesiac.',
      new_blog_articles: 'Nové články z nášho blogu – maximálne 1x za týždeň.',
      account_cancellation_undone: 'Zrušenie účtu sa nedá vrátiť. Ste si istý, že chcete svoj účet zrušiť?',
      no_posts_saved: 'Zatiaľ nemáte uložené žiadne príspevky.',
      no_events_saved: 'Zatiaľ nemáte uložené žiadne podujatia.',
      no_job_offer_saved: 'Zatiaľ nemáte uložené žiadne pracovné ponuky.',
      confirm_email_address: 'Na e-mailovú adresu <span class="tw-font-bold">{email}</span> sme Vám poslali odkaz na potvrdenie e-mailu. Skontrolujte si svoju e-mailovú schránku, pre istotu aj priečinok spam.',
      basic_information: 'Základné informácie, ktoré musí mať každé CV',
      about_me_input: '2-3 krátke vety o tom, kto ste a na čo sa špecializujete',
      employment: 'Uveďte informácie o svojom zamestnaní. Začnite od najnovšieho alebo aktuálneho.',
      stack: 'Zoberte si až 9 špecializácií, ktoré sú pre vás najcennejšie a máte v tom najviac skúseností.',
      stack_notify: 'Už sme pre vás vybrali niektoré technológie z predchádzajúcej sekcie 😎',
      education: 'Poskytujte informácie o svojej strednej, vysokej alebo vysokej škole. Začnite od najnovších.',
      education_diploma_placeholder: 'Majster inžinierstva alebo čo, neviem neštudoval som...',
      references: 'Pridajte informácie o projektoch, na ktorých ste pracovali a sú už online.',
      references_description_input: 'Napíšte krátky popis projektu alebo ponechajte prázdne.',
      certificates: 'Ak máte nejaké certifikáty, ktoré chcete ukázať, toto je to miesto.',
      certificates_description_input: 'V prípade potreby napíšte krátky popis',
      languages: 'Dajte svojmu budúcemu zamestnávateľovi vedieť, akými jazykmi hovoríte.',
      technology_input: 'Vyberte technológie, ktorý ste používali počas zamestnania.',
      employment_description_input: 'Napíšte asi 3-7 viet o svojej práci a o tom, za čo ste boli zodpovední.',
      education_description_input: 'Napíšte asi 3-6 viet o svojom štúdiu.',
      cv_generation_in_progress: 'Váš životopis sa generuje. Po dokončení dostanete životopis do vašej e-mailovej schránky: <b>{email}</b>',
    },
    actions: {
      fill_position: 'Doplňte svoju pozíciu',
      respond_to_offer: 'Reagovať na ponuku',
      move_down: 'Posunúť nižšie',
      move_up: 'Posunúť vyššie',
      delete_photo: 'Odstrániť fotografiu',
      change_photo: 'Zmeniť fotku',
      upload_photo: 'Nahrať fotku',
      delete_custom_cv: 'Odstrániť CV',
      change_custom_cv: 'Zmeniť CV',
      upload_custom_cv: 'Nahrať CV',
      go_to_events: 'Prejsť na podujatia',
      show_posts: 'Zobraziť príspevky',
      find_job: 'Nájsť prácu',
      send_cv_by_email: 'Poslať emailom',
      show_resume: 'Pozrieť CV',
      create_koderia_cv: 'Vytvoriť Koderia CV',
      pick_previous_tech: 'Vyberte technológie z predchádzajúcuj práce',
    },
    inputs: {
      dominated_technologies: 'Ovládané technológie',
      bio: 'Bio',
      current_email: 'Aktuálny e-mail',
      new_email: 'Nový e-mail',
      new_password: 'Nové heslo',
      url_link: 'URL odkaz',
      description: 'Popis',
      country: 'Krajina',
      education_diploma: 'Dosiahnuté vzdelanie / Diplom',
      school_university: 'Škola/Univerzita',
      faculty: 'Fakulta',
      technology_software_activity: 'Technológia, softvér, činnosť…',
      numbers_of_years_of_experience: 'Počet rokov praxe',
      language: 'Jazyk',
      level: 'Úroveň',
      link: 'URL',
      web_social_network: 'Web / Sociálna sieť',
      about_me: 'Krátke info o tebe',
      new_jobs: 'Nové pracovné pozície',
      koderia_news: 'Koderia novinky',
      profession_finish_up: 'Čo najlepšie vystihuje vašu profesiu?',
      country_finish_up: 'Odkiaľ pochádzate?',
      technologies_finish_up: 'Ktoré technológie používate?',
      technologies: 'Technológie',
      non_it: 'Nie som IT človek',
      source_about_us: 'Ako ste sa o nás dozvedeli?',
      non_it_registration_reason: 'Prečo ste sa rozhodli zaregistrovať?',
    },
    posts: 'Príspevky',
    data_in_cv: 'Údaje',
    basic_information: 'Základné informácie',
    education: 'Vzdelanie',
    school: 'Škola',
    references: 'Referencie',
    reference: 'Referencia',
    technologies: 'Technológie',
    years_of_experience: 'Roky skúsenosti',
    certificates: 'Certifikáty',
    certificate: 'Certifikát',
    languages: 'Jazyky',
    experience_chart: 'Graf skúseností',
    import_your_data_from: 'Importujte svoje dáta z',
    linkedin: 'LinkedInu',
    link: 'Odkaz',
    language: 'Jazyk',
    app_language: 'Jazyk aplikácie',
    contact_information: 'Kontaktné údaje',
    privacy: 'Súkromie',
    graph: 'Graf',
    public: 'Verejný',
    registered_users: 'Registrovaní užívatelia',
    private: 'Súkromný',
    accessible_with_password: 'Prístupný s heslom',
    job_looking_finish_up: 'Hľadáte si v súčasnosti prácu?',
    job_timeframe_finish_up: 'V akom časovom horizonte si plánujete hľadať prácu?',
    job_listing_title: 'Pracovné pozície',
  },
  gdpr: {
    title: 'Ochrana súkromia',
    default_agree: 'Súhlasím so spracovaním osobných údajov podľa aktuálnych',
    personal_data: 'zásad ochrany osobných údajov',
    descriptions: {
      privacy_policy_tooltip: 'Kliknutím na zaškrtávacie políčko „Súhlasím so spracovaním osobných údajov podľa aktuálnych zásad ochrany osobných údajov“ udeľujete Prevádzkovateľovi súhlas so spracovaním Vašich osobných údajov. Účelom získavania Vašich osobných údajov je poskytnúť Vám na základe Vašej žiadosti informáciu o adekvátnej výške platu na konkrétnej zvolenej pozícii. Svoj súhlas so spracovaním osobných údajov udeľujete na dobu 3 rokov a máte právo ho kedykoľvek odvolať na e-mailovej adrese <u>kontakt@koderia.sk</u>. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania osobných údajov založenom na súhlase pred jeho odvolaním.',
      receive_job_offers: 'Nesúhlasím s občasným zasielaním na mieru šitých pracovných ponúk',
      contact_tooltip: 'Kliknutím na zaškrtávacie políčko „Súhlasím so spracovaním osobných údajov podľa aktuálnych zásad ochrany osobných údajov“ udeľujete Prevádzkovateľovi súhlas so spracovaním Vašich osobných údajov a s ich uchovávaním v internej databáze. Účelom spracovania Vašich osobných údajov je nájdenie vhodnej pracovnej pozície. Svoj súhlas so spracovaním osobných údajov udeľujete na 5 rokov a máte právo ho kedykoľvek odvolať na našej na e-mailovej adrese <u>kontakt@koderia.sk</u>. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania osobných údajov založenom na súhlase pred jeho odvolaním.',
      register_account_tooltip: 'V rámci registrácie kliknutím na zaškrtávacie políčko „Súhlasím so spracovaním osobných údajov podľa aktuálnych zásad ochrany osobných údajov“ udeľujete súhlas so spracovaním osobných údajov a s ich uchovávaním na dobu existencie účtu. O zrušenie účtu môžete kedykoľvek požiadať a svoj súhlas so spracovaním osobných údajov odvolať na našej na e-mailovej adrese <u>kontakt@koderia.sk</u>. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania osobných údajov založenom na súhlase pred jeho odvolaním. Na základe právneho základu oprávneného záujmu Vám budeme v súvislosti s vytvorením účtu zasielať náš newsletter s voľnými pracovnými pozíciami a inými informáciami, ktoré by pre Vás mohli byť zaujímavé. V prípade, že si zasielanie newslettra neželáte, môžete jeho zasielanie kedykoľvek zrušiť v nastaveniach účtu, sekcia e-mailové nastavenia.',
      newsletter_personalized_offers: 'Súhlasím so zasielaním personalizovaných pracovných ponúk a noviniek',
      newsletter_contact_me_tooltip: 'Kliknutím na zaškrtávacie políčko „Súhlasím, aby ma Kodeira v budúcnosti kontaktovala a zasielala mi zaujímavé novinky“ udeľujete Prevádzkovateľovi súhlas s uchovávaním osobných údajov v internej databáze na účel zasielania marketingových ponúk. Účelom spracovania a uchovávania Vašich osobných údajov je zasielať Vám marketingové ponuky, ktoré by pre Vás mohli byť zaujímavé. Svoj súhlas so spracovaním osobných údajov týkajúci sa odberu newslettra udeľujete na dobu 5 rokov a máte právo ho kedykoľvek odvolať na našej Webovej stránke prostredníctvom e-mailovej adresy <u>kontakt@koderia.sk</u>. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania osobných údajov založenom na súhlase pred jeho odvolaním. Po uplynutí doby udelenia súhlasu alebo po odvolaní súhlasu so spracovaním osobných údajov bude Váš CV vymazaný.',
      project_interest_agree_to_contact: 'Súhlasím, aby ma Koderia v budúcnosti kontaktovala a zasielala mi zaujímavé novinky',
    },
  },
  404: {
    title: 'Stránka nebola nájdená',
    subtitle: 'Hľadali ste svoj nový job?',
    action: 'Všetky joby',
  },
  about: {
    title: 'Tím profesionálov',
    subtitles: {
      way_to_success: 'Naša cesta k úspechu',
      outsourcing_pros: 'Výhody outsoucingu s Koderiou',
      contractors_db: '12+ tisíc kontraktorov v našej internej databáze',
      personal_approach: 'Osobný prístup',
      selection_process: 'Kvalitný výberový proces',
      contact_us: 'Kontaktujte nás',
      koderia_team: 'Kodéria tím',
    },
    descriptions: {
      objectify: 'Koderia spája outsourcing IT špecialistov s komplexnými službami na rôznych úrovniach zodpovednosti – od nasadenia skúseného tímu, ktorý sa agilne zapojí do vášho projektu, až po dodanie softvéru na kľúč, kde preberáme celý vývoj od zadania po nasadenie. Od začiatku až do konca. Dlhodobo spolupracujeme s poprednými firmami na Slovensku, v Česku, Rakúsku a USA.',
      years_of_experience: 'rokov skúseností na trhu',
      revenue: 'Výnosy za minulý rok',
      candidates_count: 'vývojárov',
      enterprise_clients_count: 'podnikových  klientov',
      satisfied_it: 'spokojných IT špecialistov',
      monthly_developers_growth: 'nárast kandidátov v databáze mesačne',
      satisfied_clients: 'spokojných klientov',
      delivered_candidates: 'úspešne doručených človekohodín',
      rocket: {
        '2025': 'Zlúčenie značiek <span class="tw-text-koderia-alt tw-font-bold">Objectify a Koderia</span>',
        '2023_1': 'Mzdová kalkulačka',
        '2023_2': 's viac ako 500 tisíc použitiami',
        '2022': 'Prekonanie 2 miliónového obratu',
        '2021_1': 'Založenie',
        '2021_2': 'Koderia CV',
        '2021_3': 'a možnosť prihlásenia na portál',
        '2020_1': 'Spustenie bezkonkurenčnej',
        '2020_2': 'Mzdovej kalkulačka',
        '2019': 'Vytvorenie značky',
        '2018_1': 'Spustenie portálu Coders by Coders / Spustenie služby',
        '2018_2': 'Adekvátny plat',
        '2014': 'Založenie Software House <span class="tw-text-koderia-alt tw-font-bold">Objectify, sro</span>',
      },
      contractors_db: 'Pričom ku každému programátorovi máme skills rozdelené do kompetenčných centier, kde vieme presne zacieliť pracovné ponuky. Naši špecialisti majú širokú škálu odborných zručností, vrátane software developmentu, bezpečnosti dát, cloudových technológií a mnoho ďalších oblastí IT.',
      personal_approach: 'Ku každému kontraktorovi / programátorovi pristupujeme ako keby robil v našej firme. Veríme, že náš tím profesionálnych IT špecialistov vám môže poskytnúť nielen vysoko kvalitné IT služby, ale aj pocit práce s výnimočným tímom, ktorý je plne oddaný úspechu vašich projektov.',
      selection_process: 'Každý člen tímu prešiel dôkladným výberovým procesom a má skúsenosti s prácou na rôznych projektoch v rôznych odvetviach. Poskytujeme profesionálnych IT špecialistov s bohatými skúsenosťami a odbornými znalosťami na projekty našich klientov.',
      feedback: 'Vaša spätná väzba je pre nás veľmi dôležitá, pretože nám umožňuje zlepšovať naše služby a prispievať k vytváraniu lepšej komunity pre programátorov.',
      count_with_us: 'Sme tu, aby sme vám pomohli s informáciami a našli riešenia, ktoré vyhovujú vašim potrebám.',
      form_sent_thank_you: 'Ďakujeme za správu!',
    },
    inputs: {
      name: 'Meno a priezvisko *',
      phone: 'Telefón *',
      url: 'Spoločnosť alebo Linkedin profil',
      message: 'Správa *',
      gdpr: 'Súhlasím so spracovaním osobných údajov',
    },
  },
  resume: {
    title: 'CV',
    subtitles: {
      modern_clear_cv: 'Moderný a prehľadný CV<br class="tw-hidden lg:tw-block" /> pre každého v IT.',
      modern_clear_cv_free: 'Zadarmo.',
      tailored_cv: 'CV prispôsobené<br/> vaším potrebám',
      unique_graph: 'Skúsenosti zobrazené v prehľadnom grafe',
      ready_to_print: 'CV pripravené na tlač aj bezpečné zdieľanie',
      experience_salary: 'Suma, ktorú by ste mali zarábať na základe skúseností',
      reviews: 'Hodnotenia',
      start_new_cv: 'Začnite písať svoje nové CV',
      cv_is_secure: 'CV je zabezpečený',
    },
    subheadings: {
      experience_chart: 'Graf skúseností',
      print_share: 'Zdieľanie aj tlač',
      adequate_salary: 'Adekvátny plat',
      responsive_design: 'Responzívny dizajn',
      english_language: 'Anglický jazyk',
      password_protected: 'Chránený heslom',
      it_sector_oriented: 'Orientovaný na IT sektor',
      linkedin: 'LinkedIn Import',
      easy_edit: 'Jednoduchá úprava',
      faq_1: 'Je vytvorenie CV naozaj zadarmo?',
      faq_2: 'Ako môžem zdieľať svoje CV?',
      faq_3: 'Je CV dostupné v iných jazykoch?',
      faq_4: 'Ako si do CV importujem údaje z LinkedInu?',
    },
    descriptions: {
      create_responsive_resume: 'Vytvorte si v priebehu pár minút responzívne CV, ktorý môžete kedykoľvek <b>upraviť</b>,<br class="tw-hidden lg:tw-block" /> <b>zdieľať</b> či <b>vytlačiť</b>.',
      tailored_cv: 'Koderia CV je vhodný pre všetkých ľudí pracujúcich v IT priemysle vrátane frontend, backend a fullstack developerov, testerov, IT špecialistov, administrátorov či databázistov.',
      understand_experiences: 'Aké by to bolo vidieť svoje skúsenosti a porozumieť im za pár sekúnd? Práve to umožňuje graf, ktorý vizualizuje vaše dosiahnuté skúsenosti.',
      share_and_print: 'Zdieľajte svoj CV s každým alebo iba s ľuďmi, pre ktorých je určený. Ak bude treba vytlačte si ho rovnako dokonalý, ako na dispeji.',
      experience_salary: 'CV vám ukáže sumu, ktorú by ste mali zarábať na základe skúseností, ktoré ste uviedli v CV.',
      displayed_on_device: 'CV sa zobrazí bez problémov na akomkoľvek zariadení',
      english_switch: 'Svoj CV môžete jedným klikom prepnúť do angličtiny',
      intended_share: 'Ukážte svoj CV všetkým alebo iba ľuďom, pre ktorých je určený',
      unique_design: 'Jedinečný dizajn CV pre ľudí, ktorí hľadajú prácu v IT odvetví',
      linkedin_import: 'Údaje do CV môžete jednoducho preniesť zo svojho LinkedIn účtu',
      edit_freely: 'Upravte svoj CV kedykoľvek to bude potrebné a z akéhokoľvek zariadenia',
      faq: 'Spísali sme niekoľko odpovedí na otázky, ktoré by vás mohli zaujímať. Ak máte ďalšie, neváhajte nám napísať.',
      faq_1: 'Je. Za vytvorenie, zdieľanie či tlač svojho CV neplatíte vôbec nič. Žiadne reklamy, žiadne skryté poplatky. Nemáte za čo! 😎',
      faq_2: 'Vaše CV bude prístupné na predvytvorenom odkaze v tvare <b>koderia.sk/cv/id</b>. Tento odkaz môžete poslať komukoľvek.',
      faq_3: 'Je. Tak ako náš web aj CV je dostupné v dvoch jazykoch – anglický a slovenský.',
      faq_4_1: 'Stačí postupovať podľa týchto krokov:',
      faq_4_2: 'Otvorte si podstránku o svojich osobných údajoch v LinkedIne – How LinkedIn uses your data',
      faq_4_3: 'Zvoľte možnosť <b>Download larger data archive</b>.',
      faq_4_4: 'Následne kliknite na <b>Request archive</b>.',
      faq_4_5: 'Súbor, ktorý si stiahnete rozbaľte a nahrajte do svojho CV súbory <b>Languages</b>, <b>Courses</b>, <b>Positions</b>, <b>Profile</b> a <b>Education</b>. Následne kliknite na <b>Importovať</b>. Berte prosím na vedomie, že LinkedIn vám súbor nemusí poskytnúť ihneď.',
      ratings: 'Čo si o Koderia CV myslia ľudia v IT, ktorí ho už vyskúšali? 🥰',
      start_new_cv: 'Dali sme si záležať na tom, aby každé CV-čko vyzeralo dokonale. Druhý krok už nechávame na vás.',
      private_access: 'CV je buď súkromný, prístupný pre registrovaných užívateľov alebo chránený heslom.',
    },
    actions: {
      create_resume: 'Vytvoriť CV',
      show_sample: 'Ukážka vzorového CV',
    },
    invitation: 'Pozvánka',
  },
  newsletter: {
    subtitles: {
      android_ios_projects: 'Najčerstvejšie Android a iOS projekty do vašej schránky',
      personalized_jobs: 'Personalizované pracovné ponuky do vašej schránky',
    },
    descriptions: {
      send_personalized_projects: 'Do schránky vám pošleme iba personalizované projekty, ktoré sa zhodujú s vašim zameraním.',
      no_spam: 'Nikdy nie spam',
      koderia_newsletter: 'V Koderia Newsletteri nájdete len tie pracovné ponuky, ktoré vás naozaj zaujímajú. Nikdy nie spam.',
    },
  },
  promo: {
    title: 'projekty pre celé tímy (35+ ľudí)',
    description: 'Vytvárame nové tímy <span class="tw-font-bold">programátorov</span>, <span class="tw-font-bold">testerov</span> a <span class="tw-font-bold">scrum masterov</span> pre nové projekty z bankového sektora. Pracujte z domu pre etablovaného klienta...',
  },
  meta: {
    auth_sign_in: 'Prihlásiť sa',
    auth_forgot_password: 'Zabudnuté heslo',
    auth_create_account: 'Vytvoriť účet',
    work: 'Práca',
    events: 'Podujatia',
    blog: 'Blog',
    newsfeed: 'Newsfeed',
    dictionary: 'Slovník',
    what_is_koderia: 'Čo je Koderia?',
    adequate_salary: 'Adekvátny plat',
    adequate_salary_thank_you: 'Ďakujeme - Adekvátny plat',
    calculator: 'Mzdová kalkulačka',
    privacy_policy: 'Zásady ochrany osobných údajov',
    resume: 'CV',
    about_us: 'O nás',
    extra: 'Extra',
    newsletter: 'Newsletter',
    promo: 'Nové remote projekty pre celé tímy (35+ ľudí)',
    referral: 'Referral',
    referral_consent: 'Súhlas - Referral',
    unsubscribe: 'Unsubscribe',
    account: 'Účet',
    account_saved: 'Uložené - Účet',
    account_added: 'Pridané - Účet',
    my_resume: 'Môj CV',
    registration_completion: 'Dokončenie registrácie',
    work_types_comparison: 'Porovnanie foriem práce',
    frame_help_bratislava: 'Pomôž Bratislave v budovaní nového tímu IT špecialistov',
    frame_game_industry: 'Pracuj v hernom priemysle',
    frame_net_teams: 'Nové pracovné pozície pre .NET tímy',
    404: 'Stránka nebola nájdená',
  },
  reviews: {
    list: {
      1: {
        name: 'Adrián Slavkovský',
        position: 'Koordinátor strediska inventarizačných zručností',
        company: 'Orange S.A.',
        text_1: 'Uprostred projektu sme sa rozhodli zapojiť do integračného procesu ďalšiu krajinu. Napriek tomu sa Objectify podarilo dodať projekt v dohodnutom termíne a vo výbornej kvalite.',
        text_2: 'V spolupráci určite budeme pokračovať.',
      },
      2: {
        name: 'Ivan Tarapčík',
        position: 'Manažér ebankingových riešení',
        company: 'Asseco Central Europe',
        text: 'Spojením svojich zručností v oblasti telekomunikácií a implementáciou v jazyku Java nám chlapci z Objectify výrazne pomohli pri včasnom dodaní projektu Notifikačné centrum.',
      },
    },
  },
  company: {
    services: {
      title: 'Služby',
      subtitle: 'Sme špecialisti na váš ďalší IT projekt, <br /> ktorí robia veci správne.',
      stats: {
        1: 'vývojári',
        2: 'výnosy za minulý rok',
        3: 'podnikoví klienti',
      },
      fulfilling: {
        title: 'Naplníme všetky Vaše IT potreby. <br class="tw-block md:tw-hidden" /> Od začiatku až do konca.',
        description: 'Nájdite spôsob spolupráce, ktorý najlepšie vyhovuje vašim potrebám',
        outsourcing: {
          title: 'Outsourcing',
          description: 'Dodáme kvalifikovaných profesionálov, ktorí vyhovujú vaším potrebám. Kontrola je u Vás.',
        },
        scrum: {
          title: 'Náš tím<br class="{className}" /> na Vašom projekte',
          description: 'Poskytneme zabehnutý tím vývojárov a zabezpečíme, aby pracovali najlepším možným agilným spôsobom vývoja.',
        },
        owning: {
          title: 'Software na kľúč',
          description: 'Vy nám dáte svoj cieľ, my dodáme celé riešenie. End to end.',
        },
        responsibility: {
          title: 'Naša zodpovednosť',
          low: 'Nízka',
          high: 'Vysoká',
        },
      },
      experience: {
        title: 'Naše skúsenosti – overené projektmi',
        sectors: {
          1: 'Financie',
          2: 'Telco',
          3: 'Zdravotníctvo',
          4: 'Stávkovanie',
          5: 'Doprava',
          6: 'IT',
        },
        solutions: {
          1: 'Integrácia a migrácia údajov',
          2: 'Veda o údajoch / Vizualizácia údajov',
          3: 'Správa dokumentov',
          4: 'Dátový sklad a výkazníctvo',
          5: 'Web',
          6: 'HR / Sourcing',
          7: 'Riadenie IT projektov',
          8: 'Dev/Ops',
        },
        level: {
          expert: 'Odborníci',
          high_exp: 'Vysoké skúsenosti',
          medium_exp: 'Nejaké skúsenosti',
          low_exp: 'Nízke skúsenosti',
          no_exp: 'Žiadne skúsenosti',
        },
      },
      benefit: {
        title: 'Výhody outsourcingu s Koderia',
        subtitle: 'Potrebujete podnikové riešenie? <br /> Vytvárame robustný, spoľahlivý, škálovateľný a rýchly softvér.',
        personal_benefits: {
          1: {
            title: '12 000+ dodávateľov v našej internej databáze',
            description: 'Pričom ku každému programátorovi máme skills rozdelené do kompetenčných centier, kde vieme presne zacieliť pracovné ponuky. Naši špecialisti disponujú širokou škálou odborných znalostí vrátane vývoja softvéru, bezpečnosti údajov, cloudových technológií a mnohých ďalších oblastí IT.',
          },
          2: {
            title: 'Osobný prístup',
            description: 'Každého dodávateľa/ programátora považujeme za súčasť našej vlastnej spoločnosti. Veríme, že náš tím profesionálnych IT špecialistov vám môže poskytnúť nielen kvalitné IT služby, ale aj skúsenosti z práce s výnimočným tímom, ktorý sa plne venuje úspechu vášho projektu.',
          },
          3: {
            title: 'Výberový proces vysokej kvality',
            description: 'Každý člen tímu prešiel dôkladným výberovým procesom a má skúsenosti s prácou na rôznych projektoch v rôznych odvetviach. Pre projekty našich klientov poskytujeme profesionálnych IT špecialistov s rozsiahlymi skúsenosťami a odbornými znalosťami.',
          },
        },
        enterprise_benefits: {
          1: {
            title: 'Integrácia údajov',
            subtitle: 'Sú vaše údaje rozptýlené v množstve aplikácií, ktoré vám bránia získať jedno súhrnné zobrazenie alebo prehľad?',
            description: 'Podobná situácia je v mnohých organizáciách – údaje sú rozložené v mnohých aplikáciách, na rôznych miestach, alebo rôznych formátov. Neexistuje jednoduchý spôsob, ako sa pozrieť na všetky údaje a vyhodnotiť ich. Údaje je potrebné skopírovať a kombinovať ručne, čo si vyžaduje ľudskú prácu a zaberá veľa času. <br /> <br /> Sťahujeme, posúvame a kombinujeme údaje zo všetkých typov zdrojov bez ohľadu na lokalitu alebo technológiu. My poskytujeme komplexné prehľady, analýzy a grafické zobrazenia vašich údajov, čo výrazne zlepšuje tvorbu vášho podnikania.',
          },
          2: {
            title: 'Vysoká dostupnosť',
            subtitle: 'Spôsobujú vám výpadky IT systémov finančné straty?',
            description: 'V dnešnom svete nie je mnoho spoločností, ktoré si môžu dovoliť výpadky v poskytovaní služieb, ktoré by viedli k nespokojnosti zákazníkov. Ak aplikácia musí byť v prevádzke 24 hodín denne, 7 dní v týždni, dopyt po spoľahlivej službe, ktorá perfektne funguje aj počas aktualizácií, je ešte väčší. Naše riešenia umožňujú upgrade bez výpadku poskytovania služieb. <br /> <br /> Implementujeme systémy s architektúrou vysokej dostupnosti, ktoré vám pomôžu minimalizovať prestoje systému. Naše riešenie zabezpečuje, že kritické komponenty sú pripravené na akékoľvek neočakávané udalosti, ktoré by mohli spôsobiť výpadok serverov.',
          },
          3: {
            title: 'Vysoká škálovateľnosť',
            subtitle: 'Je váš systém pripravený zvládnuť rastúci počet používateľov alebo dátové zaťaženie?',
            description: 'Mnohé firmy sa stretávajú s problémom, že ich systémy nie sú schopné poskytovať služby viacerým zákazníkom resp. rozšírenie ich služieb by viedlo k nižšej kvalite. Výkon ich aplikácií limituje rast ich podnikania. <br /> <br /> Vytvárame aplikácie, ktoré zvládnu čoraz väčší počet používateľov, funkcií, geografických lokalít a dátové zaťaženie. Naše systémy sú prispôsobiteľné požiadavkám rastúceho podnikania a sú vysoko škálovateľné.',
          },
          4: {
            title: 'Automatizované testovanie',
            subtitle: 'Koľko úsilia musíte vynaložiť na manuálne testovanie po každej malej zmene v systéme?',
            description: 'Ak nemôžete vykonať zmeny v zdrojovom kóde aplikácie bez obavy, že niečo prestane fungovať, je čas pozrieť sa na automatizované testovanie. To isté platí, ak váš testovací tím potrebuje veľa času na opakované testovanie starých funkcií po každom vydaní. <br /> <br /> Pomáhame klientom vytvárať testy, ktoré odhaľujú nefunkčné funkcie v backendových službách alebo defekty frontendu aplikácie. V našich projektoch využívame vývoj riadený testami. Každú nahlásenú chybu opravujeme pomocou špecifických testov. Vyvinuli sme tiež Testissimo – jedinečné riešenie pre automatizované testy používateľského rozhrania (UI).',
          },
        },
        actions: {
          show_more: 'Zobraziť viac',
          show_less: 'Zobraziť menej',
        },
      },
      features: {
        title: 'Vytvárame softvér od roku 2014. Milujeme kvalitu, udržateľnosť a funkčnosť. <br /> Tiež máme radi, keď veci fungujú rýchlo.',
        1: {
          title: 'Vysoká škálovateľnosť',
          description: 'Využite našich vývojárov, ktorí vyhovujú potrebám vášho projektu/ Ostatné je na vás.',
        },
        2: {
          title: 'Nasadzovanie',
          description: 'Nasadzujeme často. Nie každé dva týždne, nie každé štyri týždne, ale hneď, ako to dáva zmysel.',
        },
        3: {
          title: 'Duplikovanie',
          description: 'Dbáme na to, aby sme neduplikovali algoritmy. Duplikácia môže byť zdrojom všetkých problémov v softvéri.',
        },
        4: {
          title: 'Kontrola kvality',
          description: 'Na zabezpečenie kvality používame požiadavky na stiahnutie. Požiadavky na stiahnutie bez automatických testov nie sú našou šálkou čaju.',
        },
      },
    },
    cases: {
      banner: {
        title: 'Sme špecialisti na váš ďalší IT projekt, ktorí robia veci správne.',
        description: 'Naplníme všetky Vaše IT potreby. Od začiatku až do konca.',
        action: 'Zistite viac',
      },
      subtitles: {
        problem_definition: 'Definícia problému a cieľ',
        challenges: 'Výzvy',
        solutions: 'Riešenia',
      },
      competencies: 'Kľúčové kompetencie',
      technologies: 'Technológie',
      features: {
        data_analytics: 'Analýza dát',
        data_visualization: 'Vizualizácia dát',
        data_warehouse: 'Dátový sklad',
        data_integration: 'Integrácia údajov',
        data_modeling: 'Dátové modelovanie',
        document_management: 'Správa dokumentov',
        distributed_applications: 'Distribuované aplikácie',
        android_app: 'Vývoj aplikácií pre Android',
        application_integration: 'Integrácia aplikácií',
        agile_development: 'Agilný vývoj',
        automated_testing: 'Automatizované testovanie',
        high_availability: 'Vysoká dostupnosť',
        high_scalability: 'Vysoká škálovateľnosť',
        high_data_volume_processing: 'Spracovanie veľkého objemu dát',
        microservices: 'Mikroslužby',
      },
      domains: {
        railways: 'Železnice',
        construction: 'Stavebníctvo',
        renewable_energy: 'Obnoviteľná energia',
        biometrics: 'Biometria',
        telecommunications: 'Telekomunikácie',
        healthcare: 'Zdravotníctvo',
        community: 'Spoločenstva',
      },
      list: {
        railways: {
          title: 'Dátový sklad pre defektoskopiu železníc',
          description: 'Železnice Slovenskej republiky si objednali diagnostické vozidlo na nedeštruktívne testovanie od konzorcia spoločností, ktoré dodalo vozidlo, meracie technológie a softvér na vyhodnocovanie všetkých nameraných údajov. Pre toto konzorcium sme vytvorili sklad a analytický nástroj, ktorý zobrazuje dáta v užívateľsky prívetivom portáli.',
          problem_definition: 'Meracie systémy produkujú obrovské množstvo dát, ktoré je potrebné preniesť do dátového úložiska a následne vyčistiť a transformovať do formátu zrozumiteľného pre bežného používateľa. Vzhľadom na veľkosť databázy, ktorá sa odhaduje na cca 5 TB, musia byť dáta transformované do formátu, ktorý je optimalizovaný pre budúce zobrazenie na portáli. Aplikácia musí poskytovať používateľské rozhranie, ktoré zobrazuje požadované dáta s rýchlymi odozvami a je schopné prezentovať namerané dáta na podkladovej mape.',
          challenge: {
            description: 'Projekt zahŕňa veľký objem nameraných dát, ktoré je potrebné preniesť z lokomotívy na server, následne vyčistiť a transformovať do formátu, ktorý umožňuje neskoršiu analýzu dát a poskytuje krátke odozvy pre prezentačnú vrstvu.',
            list: {
              1: {
                title: 'Spolupráca viacerých dodávateľov',
                description: 'Jednou z výziev bolo aj zabezpečenie spolupráce medzi viacerými spoločnosťami, vrátane viacerých dodávateľov meracích systémov a viacerých dodávateľov softvérových riešení.',
              },
              2: {
                title: 'O zákazníkovi',
                description: 'Železnice Slovenskej republiky spravujú štátnu železničnú infraštruktúru na území Slovenskej republiky a zároveň poskytujú aj dopravné služby.',
              },
            },
          },
          solution: {
            description: 'Dátový sklad konsoliduje rozsiahle množstvo informácií zozbieraných z meracích systémov nainštalovaných na lokomotíve. Tento sklad efektívne ukladá, čistí a transformuje surové namerané dáta do štruktúrovaného formátu, čo umožňuje komplexnú analýzu a reporting. Podporuje pokročilé analýzy dát, uľahčuje identifikáciu defektov koľajníc, trendov a vzorov v priebehu času.',
            list: {
              1: {
                title: 'Kampane',
                description: 'Merania vybraných úsekov trate sú vopred naplánované ako súčasť meracej kampane. Pri vytváraní kampane musí používateľ definovať celý plán trasy pre diagnostické vozidlo, vrátane detailov o rýchlosti vozidla, typoch diagnostiky a plánovaných zastávkach na staniciach.',
              },
              2: {
                description: 'Po dokončení kampane si môže používateľ prezerať a analyzovať zozbierané dáta. Je možné stiahnuť pôvodné súbory vytvorené meracími systémami, prezerať si obrázky alebo videá z kamier a lokalizovať defekty na mape.',
              },
              3: {
                description: 'Kampane a všetky priradené súbory majú svoj vlastný životný cyklus, ktorý používateľom pomáha analyzovať výsledky a plánovať následné opravy.',
              },
              4: {
                title: 'Panel',
                description: 'Aplikácia obsahuje komplexný panel s interaktívnymi dlaždicami, ktorý používateľom umožňuje jednoduchú navigáciu na rôzne obrazovky, ako sú reporty, kampane alebo súbory. Každá dlaždica poskytuje rýchly prístup k rôznym funkciám, čím zaisťuje intuitívne a efektívne používateľské prostredie. Panel slúži ako centrálny uzol, ktorý ponúka prehľad kľúčových informácií a funkcií. Používatelia majú prístup k podrobným reportom, spravujú dáta kampaní a navigujú na všetky ostatné obrazovky priamo z panela.',
              },
              5: {
                title: 'Reporty',
                description: 'Aplikácia obsahuje rôzne reporty na podporu komplexnej analýzy dát a rozhodovania. Tieto reporty zahŕňajú výstupy z meraní, ktoré podrobne popisujú dáta zozbierané počas kampaní. Reporty o chybách upozorňujú na akékoľvek anomálie alebo problémy zistené v dátach. Reporty o hodnotení úsekov poskytujú hodnotenie špecifických úsekov trate, zatiaľ čo reporty o stave meraní ponúkajú aktuálne informácie o priebehu a výsledkoch prebiehajúcich meraní. Okrem toho reporty s čelnými fotografiami prezentujú vizuálnu dokumentáciu z kamier, ktorá pomáha pri identifikácii a overovaní defektov. Každý report je navrhnutý tak, aby poskytoval jasné a použiteľné informácie, čím sa zvyšuje celková efektívnosť a účinnosť procesu údržby železníc.',
              },
            },
          },
        },
        cx_android: {
          title: 'Cx Aplikácia pre Android',
          description: 'Aplikácia poskytuje funkcionalitu pre správu úloh súvisiacich s uvádzaním stavebných projektov do prevádzky. Uľahčuje kolaboratívnu správu problémov, sleduje majetok a zabezpečuje overovanie kvality pomocou kontrolných zoznamov a testov.',
          problem_definition: 'Náš zákazník mal existujúci softvér na správu uvádzania do prevádzky prístupný cez webový prehliadač ako bežnú webovú aplikáciu alebo ako aplikáciu pre iOS dostupnú v App Store. Potrebovali aplikáciu pre Android, ktorá by poskytovala identickú funkcionalitu s aplikáciou pre iOS.',
          challenge: {
            list: {
              1: {
                title: 'Zákazník',
                description: 'CxAlloy poskytuje softvér na správu uvádzania do prevádzky a softvér na správu zariadení zákazníkom v Severnej Amerike.',
              },
              2: {
                title: 'Základné funkcie',
                list: {
                  1: 'Podpora viacerých projektov',
                  2: 'Automatická synchronizácia so serverom',
                  3: 'Používanie v režime offline',
                  4: 'Vytváranie a úprava terénnych pozorovaní',
                  5: 'Overovanie kvality pomocou kontrolných zoznamov a testov',
                  6: 'Správa problémov',
                  7: 'Sledovanie majetku',
                },
              },
            },
          },
          solution: {
            list: {
              1: {
                description: 'Aplikácia umožňuje používateľom spravovať viacero projektov. Zabezpečuje synchronizáciu zmien dát medzi klientom a aplikačným serverom. Viacerí používatelia môžu pracovať na tom istom projekte súčasne na rôznych platformách (iOS, web, Android). Pokročilé algoritmy na strane servera zabezpečujú integritu a správnosť dát, keď ten istý projekt používajú paralelne rôzni používatelia.\n\nRôzne súbory a typy súborov (napr. obrázky alebo PDF) je možné priložiť ku každému projektu. Okrem toho môžu používatelia pridávať k týmto súborom anotácie, ktoré sa zobrazujú vo vrstve nad súborom. Táto vrstva anotácií sa dá podľa potreby upravovať.',
              },
              2: {
                description: 'Terénne pozorovania umožňujú používateľom dokumentovať ich pokrok v súvislosti s aktivitami na stavenisku. Tieto pozorovania môžu využívať rôzne roly projektu, vrátane architektov, inžinierov alebo konzultantov. Správa terénnych pozorovaní zahŕňa aj možnosť vytvárať a upravovať komentáre s možnosťou prikladania obrázkov.',
              },
              3: {
                title: 'Sledovanie problémov',
                description: 'Aplikácia umožňuje efektívnu spoluprácu pri riešení problémov s návrhom a výstavbou, ktoré môžu pochádzať z rôznych zdrojov, ako sú terénne pozorovania alebo testy. Problémy môžu zahŕňať nedostatky, otázky alebo komentáre. Aplikácia podporuje tok medzi rôznymi stavmi problému, čo môže viesť k vytvoreniu ďalších úloh alebo priradeniu problému rôznym osobám. Aplikácia obsahuje aj šablóny problémov, ktoré zjednodušujú vytváranie nových problémov.',
              },
            },
          },
        },
        pv_components: {
          title: 'Katalóg fotovoltaických komponentov',
          description: 'Vytvorili sme webovú aplikáciu, ktorej jedným z hlavných cieľov je poskytovať prístup k presným a overeným technickým špecifikáciám FV komponentov, ako sú FV moduly alebo meniče.',
          problem_definition: 'Väčšina výrobcov fotovoltaických komponentov prezentuje svoje produkty primárne na svojich webových stránkach. Keď však používatelia hľadajú možnosť porovnávať a hodnotiť položky od viacerých výrobcov štandardizovaným spôsobom, existuje len málo verejných portálov, ktoré takéto porovnávania uľahčujú. Kľúčovým cieľom tohto projektu bolo prezentovať fotovoltaické komponenty z rôznych regiónov alebo od rôznych výrobcov uceleným spôsobom.\n\nRovnako dôležité je poskytnutie API pre aplikácie tretích strán, ktoré im umožní využívať dáta z portálu pre ich vlastné účely a lepšie slúžiť svojim zákazníkom. Napríklad toto API by mohlo pomôcť pri vyhodnocovaní rôznych typov produktov pre návrh fotovoltaickej elektrárne.',
          challenge: {
            list: {
              1: {
                title: 'Implementácia',
                list: {
                  1: 'Bezserverová architektúra na AWS',
                  2: 'Fasetová navigácia s použitím iba PostgreSQL (bez použitia ElasticSearch alebo Solr)',
                  3: 'Komplexné matematické validácie',
                },
              },
              2: {
                title: 'Zákazník',
                description: 'Náš zákazník je popredným poskytovateľom fotovoltaických softvérových aplikácií a webových riešení pre optimalizáciu výstavby, vyhodnocovania a správy solárnych energetických zariadení.',
              },
            },
          },
          solution: {
            list: {
              1: {
                title: 'Základné funkcie',
                list: {
                  1: 'Registrácia FV komponentov, vrátane podpory pre viacero verzií komponentu',
                  2: 'Validácie a výpočty atribútov komponentov',
                  3: 'Možnosti vyhľadávania (fulltextové vyhľadávanie, fasetové vyhľadávanie)',
                  4: 'Porovnávania komponentov',
                  5: 'Rest API pre aplikácie tretích strán',
                  6: 'Exporty a importy komponentov v bežne používaných formátoch',
                },
              },
              2: {
                title: 'Katalóg komponentov',
                description: 'Aplikácia umožňuje používateľom zobraziť zoznam položiek, ktoré je možné filtrovať na základe rôznych kritérií, ako sú názov výrobcu, mechanické alebo elektrické charakteristiky a ďalšie. Okrem toho sú k dispozícii funkcie fulltextového vyhľadávania a fasetového vyhľadávania, ktoré používateľom uľahčujú vyhľadávanie na portáli.\n\nAplikácia je verejne prístupná.',
                a_tag: 'Prejsť do katalógu FV komponentov',
              },
              3: {
                title: 'Štatistiky',
                description: 'Okrem základnej funkcie zobrazenia katalógu ponúka aplikácia obrazovky pre vedúcich pracovníkov, ktoré im umožňujú prístup k štatistickým informáciám o zbierke položiek zobrazených v katalógu alebo využívaných spoločnosťami tretích strán. Okrem toho je štandardnou funkciou portálu poskytovanie štatistických prehľadov o využívaní API vybranými spoločnosťami.',
              },
              4: {
                title: 'Administrácia',
                description: 'Administračná sekcia portálu umožňuje komplexnú správu používateľov a spoločností. Umožňuje registráciu a správu používateľských účtov, dohľad nad registráciami spoločností a overovanie presnosti a úplnosti údajov o komponentoch. Okrem toho obsahuje nástroje na monitorovanie aktivít súvisiacich s používaním API aplikáciami tretích strán.',
              },
              5: {
                title: 'Technológie',
              },
            },
          },
        },
        enrollment: {
          title: 'Registračný portál',
          description: 'Riešenie biometrickej identifikácie na rôzne účely, od civilnej identifikácie po vyšetrovanie trestných činov.',
          features: [
            'Agilný vývoj',
            'Vizualizácia dát',
            'Integrácia aplikácií',
          ],
          problem_definition: 'Implementovali sme riešenie na zachytávanie biometrických údajov pomocou knižníc a SDK vytvorených spoločnosťou Innovatrics. Portálové riešenie ponúka funkcie, ktoré sa dajú použiť na civilnú identifikáciu alebo vyšetrovanie trestných činov. Aplikácia umožňuje použitie rôznych zariadení na zachytávanie odtlačkov prstov alebo skenov dúhovky. Okrem toho je podporovaná široká škála typov kamier.',
          challenge: {
            list: {
              1: {
                title: 'Zákazník',
                description: 'Innovatrics je nezávislý poskytovateľ dôveryhodných biometrických riešení pre vlády a podniky so sídlom v EÚ.',
              },
              2: {
                title: 'Základné funkcie',
                list: {
                  1: 'Detekcia tváre a rozpoznávanie tváre',
                  2: 'Skeny dúhovky',
                  3: 'Ploché a valcované skeny odtlačkov prstov',
                  4: 'Skeny dlaní',
                  5: 'Ručne písané podpisy',
                },
              },
            },
          },
          solution: {
            list: {
              1: {
                description: 'Všetky modality, ktoré sa získavajú od žiadateľov, sú konfigurovateľné. To znamená, že zákazník sa môže pre nasadenie rozhodnúť len s podporou napr. detekcie tváre a plochých skenov odtlačkov prstov alebo pre nasadenie s podporou všetkých funkcií.\n\nDetekcia tváre a následné rozpoznávanie tváre sú základnými funkciami registračného portálu. Skeny dúhovky sú tiež jednou z bežných funkcií ponúkaných aplikáciou.',
              },
              2: {
                title: 'Skeny odtlačkov prstov',
                description: 'Aplikácia podporuje ploché aj valcované skeny odtlačkov prstov. Pri plochej metóde môžu používatelia prepínať medzi režimom zachytávania viacerých prstov naraz a skenmi jednotlivých prstov.',
              },
              3: {
                title: 'Identifikácia žiadateľa',
                description: 'V poslednom kroku systém využíva technológie biometrického rozpoznávania na identifikáciu žiadateľa. S využitím rozpoznávania tváre, skenov dúhovky a údajov o odtlačkoch prstov aplikácia používa sofistikované algoritmy na porovnanie zachytených biometrických informácií s existujúcimi záznamami v databáze. Použitím týchto robustných biometrických modalít aplikácia zaisťuje vysokú úroveň presnosti a bezpečnosti v procese identifikácie, čím uľahčuje spoľahlivé rozhodovanie v rôznych scenároch, od civilnej identifikácie po vyšetrovanie trestných činov.',
              },
            },
          },
        },
        sia: {
          title: 'SIA – Analýza dopadu na služby',
          description: 'SIA je evolúciou nášho predchádzajúceho projektu CELINE, ktorého cieľom bola integrácia rôznych zdrojov inventárnych dát do jednej aplikácie. Hoci bol CELINE vyvinutý pre Orange France, projekt upútal pozornosť celej skupiny Orange. Konkrétne Orange Slovensko prišiel s požiadavkou nielen integrovať svoj zdroj dát súvisiacich s inventárom, ale aj využiť tieto dáta na zodpovedanie zdanlivo jednoduchých otázok: Čo by sa stalo, keby mal konkrétny sieťový prvok výpadok? Ktoré služby a zákazníci by mohli byť postihnutí a ako sa bude výpadok šíriť sieťou? Vyvinuli sme SIA, aby sme odpovedali na tieto otázky.',
          problem_definition: {
            text_1: 'Existujú tri situácie, kedy používateľ potrebuje agregovať veľké množstvo dát, aby našiel odpoveď na otázku o potenciálnom dopade na zákazníkov a ich produkty.',
            list: {
              1: 'V prípade plánovanej modernizácie, vyraďovania z prevádzky alebo akejkoľvek zmeny sieťového prvku, ktoré by mohli ovplyvniť jeho funkčnosť',
              2: 'V prípade výpadku zariadenia identifikovaného prevádzkovými tímami a monitorovacími nástrojmi',
              3: 'V prípade sťažností zákazníkov na nefunkčnosť služby',
            },
            text_2: 'Vo všetkých týchto situáciách muselo spolupracovať mnoho používateľov, pristupovať k mnohým nástrojom a kompilovať výsledky, aby našli zodpovedajúcu odpoveď. Tento proces je náchylný na chyby a v zložitejších prípadoch (napr. vyraďovanie z prevádzky metropolitného optického kábla) môže trvať až dva týždne.',
          },
          challenge: {
            description: 'Museli sme čeliť rovnakým výzvam ako v projekte CELINE. Tento projekt posúva požiadavky ešte ďalej, a teda prináša novú sadu výziev navyše k tým z projektu CELINE.',
            list: {
              1: {
                title: 'Nájdenie vzťahov v rozsiahlych grafoch v reálnom čase',
                description: 'Ak chcete vypočítať všetky služby, ktoré sa spoliehajú napríklad na daný metropolitný optický kábel, nepotrebujete len vysokokvalitné a silne korelované dáta, ale budete tiež musieť preskúmať veľké časti siete vertikálne aj horizontálne. Problém s takýmito reportmi je aj ten, že neviete, ako „hlboko“ musíte hľadať.',
              },
              2: {
                title: 'Doplnenie chýbajúcich dát',
                description: 'Hoci sa úspešne podarilo korelovať dáta zo všetkých existujúcich inventárnych systémov a všetkých systémov správy siete v Orange Slovensko, stále existovali medzery, ktoré sme museli vyplniť, aby sme mali úplný obraz o sieti. Napríklad žiadny zdroj dát nepopisoval architektúru služieb do detailov konkrétnych sieťových prvkov.',
              },
              3: {
                title: 'Vizualizácia dopadu',
                description: 'Požiadavky boli poskytnúť zoznam služieb a zákazníkov postihnutých výpadkami sieťových prvkov. Tento zoznam sa používa napríklad na informovanie zákazníkov o plánovaných výpadkoch. Aj keby sme mali zoznam, vyvstala by otázka „ako by mohol používateľ overiť, či je zoznam správny?“. Ďalšia otázka, ktorú sme museli mať na pamäti, bola „ako by mohol používateľ pochopiť, aký je reťazec výpadku, ktorý má za následok dopad na tohto konkrétneho zákazníka?“.',
              },
            },
          },
          solution: {
            description: 'Našťastie sme už mali v prevádzke produkčný systém a množstvo skúseností v oblasti integrácie telekomunikačného inventára z nášho predchádzajúceho projektu CELINE. Rozhodli sme sa znova použiť naše riešenia a kód. Taktiež sme využili túto príležitosť na modernizáciu nášho kódu, refaktorizáciu dôležitých častí, ktoré by sa neskôr stali optimalizovanejšími, a vytvorili sme lepší produkt pre použitie v projektoch CELINE aj SIA.',
            list: {
              1: {
                title: 'Nájdenie vzťahov v rozsiahlych grafoch v reálnom čase',
                description: 'Rozhodli sme sa pokračovať v používaní našej štandardnej relačnej databázy ako nášho hlavného trvalého úložiska. Aby sme však mohli vyhľadávať v rozsiahlych grafoch v reálnom čase, zaviedli sme špecializovanú grafovú databázu NEO4J, ktorá výrazne rozšírila naše možnosti pri vykonávaní analýz telekomunikačnej siete. Dáta v NEO4j sú synchronizované z našej hlavnej trvalej databázy a sú denormalizované a vylepšené, aby sa ešte viac urýchlili analýzy dopadu na sieť.',
              },
              2: {
                title: 'Doplnenie chýbajúcich dát',
                description: 'Museli sme upraviť implementáciu nášho nástroja tak, aby nielen zobrazoval a analyzoval dáta integrované z iných systémov, ale aj umožňoval používateľovi tieto dáta upravovať a ďalej vylepšovať. Časť chýbajúcich dát tvorila architektúra služieb, ktorá má prirodzene formu diagramu. Navrhli sme špecializovaný DSL (doménovo špecifický jazyk), ktorý umožňuje veľmi efektívne vytváranie takéhoto diagramu zo základných inventárnych objektov.',
              },
              3: {
                title: 'Vizualizácia dopadu',
                description: 'Aby sme používateľovi poskytli viac informácií o charakteristikách dopadu alebo dôvodoch, prečo nástroj zahrnul niektorých zákazníkov do správy o dopade, museli sme navrhnúť špecializované pohľady na dáta o dopade. Používatelia si môžu napríklad zvoliť vizualizáciu dopadu na mape, aby videli, ako sa bude dopad výpadku jednej lokality šíriť v geografickom priestore. Okrem toho si používatelia môžu vizualizovať celú cestu od konkrétnych zákazníckych zariadení k sieťovým prvkom používaným všetkými zákazníkmi pre danú službu.',
              },
            },
          },
        },
        celine: {
          title: 'Celine',
          description: 'CELINE je zastrešujúci systém správy inventára, ktorý zhromažďuje dáta od pobočiek spoločnosti Orange o ich sieťovej infraštruktúre a prezentuje ich jednotným spôsobom. CELINE používa GNOC (Globálne centrum prevádzky siete), ktoré je zodpovedné za prevádzku sietí v rôznych pobočkách spoločnosti Orange. GNOC používa CELINE ako primárny zdroj dát súvisiacich s inventárom, ktorý sa týka sieťovej infraštruktúry, ktorú spravuje.',
          problem_definition: {
            text: 'CELINE bol navrhnutý pre GNOC (Globálne centrum prevádzky siete). GNOC je zodpovedné za údržbu sieťovej infraštruktúry pobočiek spoločnosti Orange. Na dosiahnutie tohto cieľa je prístup k informáciám o infraštruktúre siete prvoradý.\n\nPôvodný prístup GNOC k správe inventára spočíval v prístupe k akýmkoľvek nástrojom, ktoré sú k dispozícii v krajine, pre ktorú poskytujú služby. Už na začiatku bolo jasné, že práca s rôznymi systémami, od rozsiahlych inventárnych riešení, ako je NetCracker, až po tabuľky Excel, nie je efektívna. Preto bolo identifikované, že by malo existovať jediné inventárne riešenie pre GNOC, ktoré integruje všetky dostupné zdroje dát. Situáciu by sme mohli opísať nasledovne:',
            header_1: 'Pred CELINE',
            header_2: 'Po CELINE',
          },
          challenge: {
            description: 'Spoločnosť OBJECTIFY bola súčasťou projektu CELINE od samého začiatku. Náš prvý príspevok k projektu spočíval v definovaní problému, ktorému čelilo GNOC: prístup k informáciám rozptýleným v mnohých rôznych zdrojoch dát. Čoskoro bolo jasné, že budeme čeliť mnohým významným výzvam:',
            list: {
              1: {
                title: 'Rozmanitosť dát',
                description: 'Aplikácie, ktoré ukladali dáta o sieťovej infraštruktúre, sa od seba výrazne líšili z hľadiska API, úrovne detailov a dátových modelov. Naším cieľom bolo vytvoriť pre používateľa jednotný pohľad na dáta. Z pohľadu používateľa by malo byť zobrazenie servera alebo smerovača (ako príklad) rovnaké bez ohľadu na to, či pôvodné dáta pochádzali z NMS (Systémy správy siete), tabuliek Excel alebo inventárneho nástroja.',
              },
              2: {
                title: 'Synchronizácia dát',
                description: 'Nebolo možné nahradiť všetky nástroje používané pobočkami spoločnosti Orange, pretože sú súčasťou každodennej práce miestnych inžinierov a sú integrované s inými špecifickými IT riešeniami.',
              },
              3: {
                title: 'Informácie namiesto dát',
                description: 'Aj keď budú dáta z rôznych zdrojov dát v rovnakej aplikácii, na poskytnutie skutočného prínosu je potrebné tieto dáta navzájom korelovať, musia byť agregované do používateľských reportov a prístupné prostredníctvom štandardizovaných API pre ďalšiu automatizáciu a reportovacie nástroje.',
              },
              4: {
                title: 'Zabezpečenie kvality dát',
                description: 'Je bežné, že inventárne systémy obsahujú neaktuálne dáta. Problém sa ešte zväčšuje, keď spoločnosti tretích strán, bez riadiacej právomoci (GNOC), musia iniciovať čistenie dát alebo aktualizovať zastarané dáta.',
              },
            },
            post_list_description: 'Existujú významné problémy so správou projektov súvisiace s projektmi s toľkými účastníkmi, ale to presahuje rámec tejto prípadovej štúdie.',
          },
          solution: {
            description: 'Spoločnosť OBJECTIFY pôsobila v oblasti správy telekomunikačného inventára dlho pred týmto projektom. Vďaka našim skúsenostiam sme získali cenné odborné znalosti, bez ktorých by sme tieto riešenia nikdy nemohli dodať:',
            list: {
              1: {
                title: 'Rozmanitosť dát',
                description: 'Vytvorili sme model inventárnych dát, ktorý začína veľmi všeobecnou terminológiou a prechádza k špecifickejším typom. Tento model sa dal rozšíriť a mohol zdokumentovať akúkoľvek inventárnu situáciu, s ktorou by sme sa mohli stretnúť v zdrojoch dát, ktoré neboli v tom čase ani identifikované. Výsledkom bol „Spoločný dátový model“, ktorý sme podrobne opísali a otestovali.',
              },
              2: {
                title: 'Synchronizácie dát',
                description: 'Vytvorili sme špecializované dátové pumpy na zhromažďovanie a transformáciu dát do „Spoločného dátového modelu“ a odosielanie agregovaného pohľadu po každej synchronizácii do centralizovaného inventára v Poľsku. Tieto dátové pumpy umožňujú vlastné pripojenia a transformácie pre každý zdroj dát. Všetky následné výpočty, transformácie a algoritmy sú generické a nezávislé od zdroja dát.',
              },
              3: {
                title: 'Zabezpečenie kvality dát',
                description: 'Vždy sa musíme uistiť, že dáta prezentované používateľovi sú správne. Implementovali sme mechanizmy na identifikáciu nekonzistencií dát, ako je integrita referencií a invarianty dát. Taktiež sme používateľom umožnili prepísať dáta pochádzajúce zo zdrojového systému a zároveň sme zabezpečili, aby boli takéto opravy konzistentne viditeľné v celej aplikácii (pôvodná hodnota zo zdroja dát a opravená hodnota od GNOC).',
              },
              4: {
                title: 'Informácie namiesto dát',
                description: 'Mať dáta neznamená, že používateľ dostane všetky informácie, ktoré potrebuje. Na vyriešenie tohto problému sme kládli veľký dôraz na možnosti vyhľadávania vo všetkých inventárnych objektoch a atribútoch. Súčasťou riešenia CELINE je integrácia s naším vlastným nástrojom DMS, ktorý poskytuje úložisko pre neštruktúrované dáta (pracovné inštrukcie, manuály, bežné problémy a riešenia) a integruje tieto informácie do CELINE. Navrhli a implementovali sme tiež mnoho vlastných reportov, ktoré sú šité na mieru pre denné informačné požiadavky inžinierov GNOC. Tieto reporty umožňujú agregovaný pohľad na dáta z rôznych zdrojov.',
              },
            },
          },
        },
        dms: {
          title: 'DMS',
          description: 'Aplikácia DMS je centralizované, webové úložisko pre všetok digitálny obsah; dokumenty, fotografie, wiki stránky a rozhodovacie stromy. Je navrhnutá na horizontálne škálovanie, aby zvládla veľké objemy dát. Súčasťou riešenia je pravidlami riadený nástroj na načítavanie, ktorý sa dokáže pripojiť k rôznym zdrojom dát a migrovať alebo synchronizovať obsah do DMS.',
          problem_definition: 'Súčasťou budovania sieťovej infraštruktúry pre telekomunikačných operátorov je vytváranie množstva rôznych dokumentov, ako sú nájomné zmluvy, CAD výkresy, merania, inštalačné materiály a podobne. Keď je telekomunikačné miesto v prevádzke, vykonávajú sa ďalšie činnosti, ako sú revízie lokality, ktoré generujú ďalšiu dokumentáciu.\n\nVšetky tieto dokumenty boli predtým uložené na jednom zdieľanom disku a s rastúcim objemom dokumentov bolo čoraz ťažšie nájsť tie správne. Na vyriešenie tohto problému začali používatelia vytvárať vlastné hierarchie priečinkov, čo znamenalo duplikovanie niektorých dokumentov. Zdieľaný disk mal aj ďalšie problémy, ako napríklad chýbajúce fulltextové vyhľadávanie, žiadna sledovateľnosť, slabá správa používateľských práv a podobne, ktoré bolo potrebné vyriešiť.',
          challenge: {
            description: 'Tento projekt zahŕňal veľké množstvo neštruktúrovaných dát, ktoré bolo potrebné kategorizovať tak, aby používatelia mohli nájsť to, čo potrebujú, bez ohľadu na ich rolu v organizácii. Dokumenty boli vytvárané a používané internými zamestnancami spoločnosti Orange, ako aj používateľmi z externých spoločností.',
            list: {
              1: {
                title: 'Organizácia dokumentov',
                description: 'Z analýzy dokumentov uložených na zdieľanom disku bolo zrejmé, že používatelia majú rôzne „pohľady“ na kategorizáciu dokumentov. Pre niektorých používateľov bola kategorizácia „orientovaná na lokalitu“, zatiaľ čo iní používatelia kategorizovali na základe „časovo orientovaných“ priorít. To viedlo k rôznym hierarchiám priečinkov a fragmentácii dokumentov.',
              },
              2: {
                title: 'Štruktúrované a neštruktúrované dáta',
                description: 'Hoci väčšina dát bola uložená v dokumentoch, niektoré informácie boli uložené v samotných štruktúrach priečinkov. Typ dokumentu, číslo lokality, rok a oveľa viac bolo zakódované v názvoch priečinkov, čo bránilo správnemu využitiu týchto informácií.',
              },
              3: {
                title: 'Duplikácia a zabezpečenie kvality',
                description: 'Často sa stávalo, že používatelia prehliadli niektoré povinné priečinky, čo viedlo k nesprávnej kategorizácii dokumentov alebo k nahratiu dokumentu, ktorý už existoval.',
              },
              4: {
                title: 'Vyhľadávanie',
                description: 'Primárnym problémom systému ukladania dokumentov na zdieľanom disku bola zlá použiteľnosť pri vyhľadávaní dokumentov. Nebolo možné použiť fulltextové vyhľadávanie a bolo ťažké navigovať cez hierarchie priečinkov a riešiť duplikáty.',
              },
              5: {
                title: 'Bezpečnosť a sledovateľnosť',
                description: 'Ak používatelia presunuli dokumenty na iné miesto alebo omylom vymazali dokumenty, nebolo možné zistiť, ktorý používateľ to bol. Taktiež nebolo jednoduché chrániť dokumenty pred neoprávneným prístupom.',
              },
              6: {
                title: 'Import dát',
                description: 'Na zdieľanom disku už bola uložená veľká množina dokumentov, ktorá musela byť načítaná do DMS bez straty informácií o jej kategorizácii.',
              },
              7: {
                title: 'Dáta na informácie',
                description: 'Používatelia nemali jednoduchú možnosť získať odpoveď na jednoduchú otázku: Koľko existuje lokalít, ktoré nemajú elektrickú revíziu za rok 2020.',
              },
            },
          },
          solution: {
            description: 'V spoločnosti OBJECTIFY sme vytvorili webový systém DMS, ktorý nebol organizovaný okolo priečinkov, ale namiesto toho umožňoval definovať vlastné polia na dokumentoch, ktoré sa dali použiť na ukladanie rôznych metadát, ako aj na vyhľadávanie.',
            list: {
              1: {
                title: 'Organizácia dokumentov a štruktúrované dáta',
                description: 'Používanie priečinkov na kategorizáciu dokumentov má niekoľko zásadných nevýhod; používatelia sa musia dohodnúť na jedinej hierarchii priečinkov a podľa toho priradiť dokumenty. Okrem toho priečinky neposkytujú žiadne informácie o dátach, ktoré obsahujú. Preto sme sa rozhodli nepoužívať priečinky vôbec. V DMS sú všetky štruktúrované informácie (Projekt, Dátum vytvorenia, Typ dokumentu, čokoľvek chcete) uložené v špecifickom atribúte dokumentu, ktorý umožňuje pokročilé filtrovanie, reportovanie o dokumentoch, validácie, pravidlá povolení na základe hodnôt atribútov a ďalšie.',
              },
              2: {
                title: 'Predchádzanie duplikácii a nesprávnej kategorizácii',
                description: 'Používatelia môžu definovať typy dokumentov a ich atribúty. Môžu si tiež prispôsobiť, ktoré polia sú povinné. Aby sme zabránili duplikovaniu obsahu používateľmi, implementovali sme vyhľadávanie na identifikáciu podobností v obsahu a upozornenie používateľa na nájdené výsledky. Okrem toho môžu používatelia definovať „Stromy nahrávania“ na jednoduché nahrávanie rôznych typov dokumentov pre daný scenár. Používatelia môžu tiež konfigurovať pravidlá na zahrnutie štruktúrovaných informácií z nahrávaných priečinkov.',
              },
              3: {
                title: 'Vyhľadávanie',
                description: 'Používame Apache Solr na indexovanie dokumentov a fulltextové vyhľadávanie so zvýrazňovaním výskytu slov, funkciami automatického dopĺňania alebo opravami pravopisu. Ďalej sme implementovali fasetové vyhľadávanie, aby používatelia mohli jednoducho zúžiť výsledky fulltextového vyhľadávania. Fasetové vyhľadávanie tiež umožňuje poradie vyhľadávania nezávislé od hierarchie; používatelia „orientovaní na lokalitu“ môžu začať filtrovaním podľa lokality a používatelia „časovo orientovaní“ filtrujú podľa časového rozsahu.',
              },
              4: {
                title: 'Bezpečnosť a sledovateľnosť',
                description: 'Implementovali sme bezpečnostný mechanizmus do DMS, ktorý sa dá jemne doladiť až na úroveň jednotlivých dokumentov. Používatelia môžu určiť prístupové práva individuálne pre každý dokument alebo konfigurovať pravidlá na základe hodnôt polí dokumentu. Okrem toho vedieme podrobný protokol o aktivite na každom dokumente, takže sa nestratí žiadna akcia používateľa.',
              },
              5: {
                title: 'Import dát',
                description: 'Aby sme mohli migrovať dáta do DMS, implementovali sme samostatný migračný nástroj s konfigurovateľným pravidlovým enginom, ktorý nielen migruje dokumenty, ale dokáže synchronizovať dokumenty z rôznych zdrojov dát (zdieľaný disk, SharePoint, databáza, …). Týmto spôsobom sa dá DMS použiť nielen ako úložisko dokumentov, ale aj ako vyhľadávač pre iné aplikácie.',
              },
              6: {
                title: 'Informácie z dát',
                description: 'Uloženie všetkých štruktúrovaných dát do vyhradených polí nám umožnilo vytvoriť reportovací engine, v ktorom môžu používatelia vytvárať tabuľkové reporty na sledovanie priebehu inštalácií, štatistiky dokumentov a oveľa viac.',
              },
            },
          },
        },
        dodes: {
          title: 'Dodes',
          description: 'Dodes je skratka pre Diagnostické uzly. Ide o metodológiu, ktorú vyvinul profesor Dr. Paul Martin Putora z nemocnice St. Gallen vo Švajčiarsku.',
          problem_definition: 'Lekárska smernica je dokument, ktorého cieľom je usmerňovať rozhodnutia a kritériá týkajúce sa diagnostiky, manažmentu a liečby v špecifických oblastiach zdravotnej starostlivosti. Tieto smernice sa pravidelne aktualizujú a často majú podobu dokumentov s „voľným textom“.\n\nPoskytovateľ zdravotnej starostlivosti je povinný poznať lekárske smernice svojej profesie a musí sa rozhodnúť, či bude pri individuálnej liečbe postupovať podľa odporúčaní smernice. Je dôležité nájsť spôsob, ako propagovať najnovšie smernice a upozorniť na prípadné odchýlky medzi smernicami a bežnou praxou.\n\nProfesor Dr. Paul Martin Putora navrhol metódu štruktúrovaného dokumentovania rozhodovacieho procesu. Použil notáciu rozhodovacieho stromu, ktorá zhustila informácie veľmi efektívnym a čitateľným spôsobom a tiež umožnila porovnávať rozhodovací proces medzi rôznymi poskytovateľmi zdravotnej starostlivosti.',
          challenge: {
            list: {
              1: {
                title: 'Zjednotenie terminológie',
                description: 'Rozhodnutia o liečbe sú založené na parametroch, ktoré môžu mať v rôznych nemocniciach rôzne názvy. Aj keď rôzne nemocnice používajú rovnaké názvy pre rovnaké parametre, môžu vyjadrovať hodnoty parametrov v rôznych jednotkách; napríklad glukóza sa môže merať v mmol/l, ako aj v mg/dl. Na vykonávanie výpočtov bolo potrebné túto terminológiu zjednotiť alebo aspoň mapovať.',
              },
              2: {
                title: 'Porovnávanie stromov',
                description: 'Rozhodovacie stromy môžu byť dokumentované rôznymi spôsobmi. Niektorí uprednostňujú používanie zložitých matematických výrazov na definovanie, kedy sa vykoná daná akcia, zatiaľ čo iní používajú jednoduché logické výrazy. Niektoré medicínske centrá môžu vynechať určité parametre, pretože merania pre daný parameter neboli vykonané. Nájdenie rozdielov v takýchto zložitých štruktúrach nebolo triviálne.',
              },
              3: {
                title: 'Obrovský stavový priestor',
                description: 'Porovnávanie rozhodovania sa vykonávalo v štúdiách, ktorých sa zúčastnilo viac ako 10 nemocníc. Jedna liečba môže závisieť od viac ako 10 parametrov. Pre vyhodnotenie takéhoto stavového priestoru môžeme ľahko skončiť s miliardami kombinácií, ktoré je potrebné vyhodnotiť.',
              },
              4: {
                title: 'Prezentácia dát',
                description: 'Rozdiely medzi liečbami môžu byť dosť zásadné. Je zložité získať správne informácie z výsledkov, pokiaľ používatelia nepreskúmajú výsledok podrobne.',
              },
            },
          },
          solution: {
            list: {
              1: {
                title: 'Zjednotenie terminológie',
                description: 'Predtým, ako sa vytvorí rozhodovací strom pre konkrétnu liečbu, musí byť terminológia zjednotená v šablóne liečby. Táto šablóna definuje slovník pre rozhodovacie stromy z hľadiska parametrov, ktoré sa musia v liečbe zohľadniť, ako aj akcií, ktoré sa dajú vykonať. Keď používateľ vytvára rozhodovací strom, systém používa šablónu na poskytnutie usmernenia a uľahčenie procesu zadávania.',
              },
              2: {
                title: 'Porovnávanie stromov',
                description: 'Implementovali sme algoritmy, ktoré dokážu transformovať rozhodovací strom na viacrozmerný stavový priestor a dokážu priradiť každej „súradnici“ množinu akcií pre daný rozsah parametrov. To nám umožňuje porovnať každú súradnicu a nájsť rozdiely. Z týchto informácií môžeme spätne vygenerovať rozhodovací strom, ktorý predstavuje výsledky porovnania. Rovnaký prístup môžeme použiť na vylepšenie validácie rozhodovacích stromov, ako napríklad výpočet rozsahov parametrov, ktoré nemajú žiadnu akciu alebo majú protichodné podmienky.',
              },
              3: {
                title: 'Obrovský stavový priestor',
                description: 'Na výpočet rozsiahlych rozhodovacích stromov z mnohých inštitúcií sme implementovali paralelizovaný výpočet pomocou fronty úloh Google. Výpočtový stavový priestor je rozdelený na mnoho menších priestorov, ktoré sa odosielajú do fronty úloh. Táto služba využíva toľko počítačov, koľko je potrebné, a vykonáva výpočet paralelne, pričom vracia výsledky, ktoré sa zlúčia do jedného výsledku porovnania. Týmto spôsobom môžeme vykonávať výpočty porovnávania takmer v reálnom čase.',
              },
              4: {
                title: 'Prezentácia dát',
                description: 'Na zredukovanie výsledkov porovnávania môžu používatelia použiť filtre akcií alebo hodnôt parametrov, a tým zredukovať stavový priestor na oveľa menšie veľkosti. Stále skúmame možnosti, ako urobiť výsledok porovnávania kompaktnejším a čitateľnejším. V súčasnosti experimentujeme s použitím korelačných matíc.',
              },
            },
          },
        },
        koderia: {
          title: 'Koderia',
          description: 'Koderia je online portál pre vývojárov a študentov so zameraním na softvérové inžinierstvo. Portál poskytuje informácie o odvetví, vrátane článkov, udalostí, ponúk práce a pôvodného obsahu – blogov. Ponúka tiež dodatočnú podporu ako kalkulačky miezd, primeraného platu, technický slovník a pod..',
          challenge: {
            description: 'Mnoho spoločností ponúka voľné pracovné miesta pre softvérových vývojárov. Museli sme sa odlíšiť a vytvoriť produkt, ktorý bude jedinečný. Zároveň bolo dôležité vybudovať dôveru medzi spoločnosťou a vývojármi.',
            list: {
              1: {
                title: 'Náš cieľ',
                description: 'Hlavným cieľom Koderie (pôvodne propagovanej ako „Vývojári pre vývojárov“) bolo zvýšiť počet odberateľov e-mailov pre naše voľné pracovné miesta v spoločnosti Objectify.',
              },
            },
            post_list_description: {
              header_1: 'Začiatok multifunkčného portálu',
              text_1: 'Začalo to ako jednoduchá webová stránka s jednoduchým formulárom, kde vývojári mohli zistiť, koľko by mali zarábať (Kalkulačka primeraného platu). Mali sme dobré znalosti o ekonomickej situácii v odvetví, takže sme boli schopní poskytovať osobné, rýchle a primerané odpovede. Kampaň bola medzi vývojármi populárna a získala stovky nových kontaktov. Vtedy sme sa rozhodli vytvoriť online priestor, ktorý spojí všetky dôležité informácie o odvetví na jednom mieste.',
              header_2: 'Prechod na Vue a Firestore',
              text_2: 'S rastom Koderie sa ukázalo, že WordPress jednoducho nebude stačiť.',
              text_3: 'Rozhodnutie ísť s Firebase sa ukázalo ako prospešné. Firebase nám ponúkol mnoho okamžite použiteľných prispôsobiteľných funkcií, ako napríklad:',
              list: {
                1: 'Databáza v reálnom čase sa používala, kým neboli potrebné rozsiahlejšie možnosti dotazovania, zatiaľ čo Firestore poskytuje všetko, čo sme potrebovali odvtedy a pravdepodobne budeme kedy potrebovať v súvislosti s projektom Koderia.',
                2: 'Funkcie Cloud sa ukázali ako vhodná náhrada za štandardný backend.',
                3: 'Autentifikácia Firebase bola príjemná funkcia na používanie a implementáciu. Poskytovatelia ako Google, Facebook, Github (a tiež štandardný e-mail + heslo) boli implementovaní s ľahkosťou.',
                4: 'Firebase CI/CD nám tiež ponúkol jednoduché riešenie nasadenia, ktoré sme nastavili a používame od nášho prvého vydania.',
              },
              text_4: 'Grafy, vizualizácie a oveľa viac sa teraz nachádza na Koderii. Veľké poďakovanie patrí chart.js. Integrácia tejto knižnice spolu s mnohými ďalšími externými aj vlastnými knižnicami bola bezproblémová.',
            },
          },
          solution: {
            list: {
              1: {
                title: 'Životopis Koderia',
                description: 'Najpokročilejšou funkciou Koderie je jedinečný životopis vyvinutý pre softvérových inžinierov. Dizajn životopisu je prispôsobený softvérovému odvetviu a pomáha komunikovať informácie jednoduchším a prehľadnejším spôsobom ako väčšina ostatných dostupných služieb na tvorbu životopisov. Vývojári sa potom môžu uchádzať o voľné pracovné miesta na Koderii alebo kdekoľvek inde. Pri vývoji tejto funkcie boli našimi hlavnými aspektmi produktu:',
                cards: {
                  1: {
                    title: 'Responzivita',
                    description: 'Životopis musel byť ľahko čitateľný na všetkých zariadeniach, ako aj pri tlači',
                  },
                  2: {
                    title: 'Výber jazyka',
                    description: 'Používatelia musia mať možnosť vybrať si jazyk',
                  },
                  3: {
                    title: 'Bezpečnosť',
                    description: 'Pre väčšie súkromie môžu používatelia prepnúť svoje životopisy do súkromného režimu',
                  },
                },
              },
              2: {
                title: 'Kalkulačka miezd',
                description: {
                  text_1: 'Kalkulačka miezd umožňuje používateľom vypočítať si svoj príjem na základe typu ich zamestnania. Funkcia prináša bohaté vizuálne zobrazenie všetkých výdavkov a daní. Hlavným cieľom je poučiť a vysvetliť, ktorý typ zamestnania je v ich situácii výhodnejší. Mnoho slovenských spoločností, najmä v IT odvetví, ponúka namiesto trvalého zamestnania zmluvu. Keďže sa mzda v týchto prípadoch líši, používateľ je informovaný o všetkých rozdieloch.',
                  text_2: 'Pre viac informácií navštívte',
                  a_tag: 'Kalkulačka miezd Koderia',
                },
              },
              3: {
                title: 'Pôvodný obsah',
                description: {
                  text_1: 'Koderia vytvára miesto, kde používatelia vždy nájdu nové a aktuálne informácie týkajúce sa softvérového odvetvia. Toto pozostáva zo sekcií, ktoré poskytujú dynamický obsah:',
                  text_2: 'Koderia si ponechala prvú funkciu – Kalkulačku primeraného platu, ktorá je teraz integrovaná aj do životopisu. Nie je potrebné vypĺňať ďalší formulár. Po vytvorení životopisu sa vypočíta aj primeraný plat.',
                  text_3: 'Počas doby, čo je projekt online, si Koderia vybudovala svoje miesto na Slovensku a plánuje pokračovať v podpore pre vývojárov, prinášať nové funkcie a vylepšovať tie existujúce.',
                },
                cards: {
                  1: {
                    title: 'Príspevky',
                    description: 'Články a videá tretích strán, starostlivo vybrané nami',
                  },
                  2: {
                    title: 'Udalosti',
                    description: 'Jedno miesto pre všetky offline a online IT udalosti na Slovensku',
                  },
                  3: {
                    title: 'Blogy',
                    description: 'Priestor pre naše myšlienky a pre každého, kto chce zdieľať svoje nápady s naším publikom',
                  },
                  4: {
                    title: 'Práca',
                    description: 'Náš primárny obsah umožňuje používateľom nájsť si svoje budúce povolanie v IT odvetví',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}

export default sk
